function accessibeeTrigger() {
  if(document.querySelector('.js-accessibility-trigger')) {
    document.querySelector('.js-accessibility-trigger').addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('.acsb-trigger').click();
    });
  }
}

window.addEventListener('DOMContentLoaded', accessibeeTrigger);

var RC;

((RC = RC || {}).cart = (function(t, e) {
    return {
        update: function(n, r, i) {
            e
                .ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: n,
                    dataType: "json",
                    cache: !1
                })
                .done(function(i) {
                    "function" == typeof r && r(i), e(t).trigger("cart:updated", [i, n]);
                })
                .fail(function(r) {
                    "function" == typeof i && i(r), e(t).trigger("cart:failure", [r, n]);
                });
        },
        add: function(newsletterData, onSuccess, onFailure) {
            e
                .ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: newsletterData,
                    dataType: "json",
                    cache: !1
                })
                .done(function(response) {
                    "function" == typeof onSuccess &&
                        onSuccess(response), e(t).trigger("cart:item_added", [response, newsletterData]);
                })
                .fail(function(response) {
                    "function" == typeof onFailure && onFailure(response), e(t).trigger("cart:failure", [response, newsletterData]);
                });
        },
        get: function(t, n) {
            e
                .ajax({
                    type: "GET",
                    url: "/cart.js",
                    dataType: "json",
                    cache: !1
                })
                .done(function(e) {
                    "function" == typeof t && t(e);
                })
                .fail(function(t) {
                    "function" == typeof n && n(t);
                });
        },
        change: function(n, r, i) {
            e
                .ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    data: n,
                    dataType: "json",
                    cache: !1
                })
                .done(function(i) {
                    "function" == typeof r && r(i), e(t).trigger("cart:changed", [i, n]);
                })
                .fail(function(r) {
                    "function" == typeof i && i(r), e(t).trigger("cart:failure", [r, n]);
                });
        },
        clear: function(t, n) {
            e
                .ajax({
                    type: "POST",
                    url: "/cart/clear.js",
                    dataType: "json",
                    cache: !1
                })
                .done(function(e) {
                    "function" == typeof t && t(e), console.log("cart cleared");
                })
                .fail(function(e) {
                    "function" == typeof t && n(e);
                });
        },
        getItem: function(t, n, r) {
            e
                .ajax({
                    type: "GET",
                    url: "/products/" + t + ".js",
                    dataType: "json",
                    cache: !1
                })
                .done(function(t) {
                    "function" == typeof n && n(t);
                })
                .fail(function(t) {
                    "function" == typeof n && r(t);
                });
        }
    };
})(RC, jQuery));

((RC = RC || {}).utils = (function(t, e) {
    return {
        shuffle: function(t) {
            var e, n, r;
            for (e = t.length - 1; e > 0; e--)
                (n = Math.floor(Math.random() * (e + 1))), (r = t[e]), (t[e] =
                    t[n]), (t[n] = r);
            return t;
        },
        urlParam: function(t) {
            return (
                decodeURIComponent(
                    (new RegExp("[?|&]" + t + "=([^&;]+?)(&|#|;|$)").exec(
                        location.search
                    ) || ["", ""])[1]
                    .replace(/\+/g, "%20")
                ) || null
            );
        },
        urlParams: function(t) {
            return (t || document.location.search)
                .replace(/(^\?)/, "")
                .split("&")
                .map(
                    function(t) {
                        return (this[(t = t.split("="))[0]] = t[1]), this;
                    }.bind({})
                )[0];
        },
        urlHash: function() {
            return window.location.hash.split("#")[1];
        },
        urlParts: function() {
            return window.location.pathname.split(/\s*\/\s*/).filter(function(t) {
                return "" != t;
            });
        },
        getClickTouch: function(t, n) {
            e(t).on("click touchstart", function(t) {
                if ((t.stopPropagation(), t.preventDefault(), !0 === t.handled))
                    return !1;
                n(t), (t.handled = !0);
            });
        },
        centsToDollars: function(t) {
            return +t % 100 == 0 ? +t / 100 : (+t / 100).toFixed(2);
        }
    };
})(0, jQuery));

var Journelle = Journelle || {};

function _toConsumableArray(t) {
    if (Array.isArray(t)) {
        for (var e = 0, n = Array(t.length); e < t.length; e++)
            n[e] = t[e];
        return n;
    }
    return Array.from(t);
}

(Journelle.templates = Journelle.templates || {});
(Journelle.sections = Journelle.sections || {});
(Journelle.modules = Journelle.modules || {});
(Journelle.collection = {});
(Journelle.product = {});
(Journelle.cart = {});
(Journelle.search = {});
(Journelle.vue = {});
(Journelle.account = {});
(Journelle.gtm = (function(t, e) {
    return (dataLayer = dataLayer || []), {
        push: function(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = arguments[2];
            return t ? (dataLayer.push(t, e), _.isFunction(n) && n(), !0) : (console.error("gtm.push: no event specified"), !1);
        }
    };
})(0, jQuery));
(Journelle.lazy = (function(t, e) {
    function n(t, e) {
        if ("string" == typeof t) {
            var n = document.querySelectorAll(t);
            return _.each(n, function(t) {
                var n = document.createElement("img");
                n.addEventListener("load", function() {
                        _.isFunction(e) && e(this, t), this.removeEventListener("load", this);
                    }), void 0 !== t.dataset.srcset &&
                    n.setAttribute(
                        "srcset",
                        t.dataset.srcset
                    ), void 0 !== t.dataset.sizes && n.setAttribute("sizes", t.dataset.sizes), n.setAttribute("src", t.dataset.src);
            }), !0;
        }
        return !1;
    }
    return {
        loadBackground: function(t) {
            n(t, function(t, e) {
                var n, r, i = window.getComputedStyle(e, null);
                "static" === i.position &&
                    (e.style.position =
                        "relative"), "auto" === i.zIndex && (e.style.zIndex = "0"), e.appendChild(((n = t.currentSrc || t.src), (r = document.createElement("div")).classList.add("lazy-inner"), r.setAttribute("style", "background-image: url(" + n + "); background-position: inherit; background-size: inherit; background-repeat: inherit; position: absolute; width: 100%; height: 100%; left: 0; top: 0; opacity: 0; transition: opacity .24s ease; z-index: -1;"), r)), e.firstElementChild.offsetHeight, (e.querySelector(".lazy-inner").style.opacity = "1"), window.setTimeout(
                        function() {
                            e.style.backgroundImage = "none";
                        },
                        240
                    ), e.classList.add("loaded");
            });
        },
        loadImage: function(t) {
            n(t, function(t, e) {
                (e.src = t.currentSrc || t.src), e.classList.add("loaded");
            });
        }
    };
})(0, jQuery));
(Journelle.newsletter = (function(t, jQuery) {
    return {
        add: function(emailAddress, n, r) {
            jQuery
                .ajax({
                    method: "POST",
                    url: "https://broker.journelle.com/api/newsletter/subscribe",
                    data: {
                        apiKey: "OoQn!VonDmMaCCvUd7X2CLXSZZsFiG",
                        email: emailAddress
                    }
                })
                .done(function(t) {
                    t && _.isFunction(n) && n(t);
                })
                .fail(function(t) {
                    console.log(t), _.isFunction(r) && r(t);
                });
        }
    };
})(0, jQuery));
(Journelle.vue.directives = (function(t, e) {
    return {
        init: function() {
            Vue.directive("click-outside", {
                bind: function(t, e, n) {
                    if ("function" != typeof e.value) {
                        var r = n.context.name,
                            i =
                            "[Vue-click-outside:] provided expression '" +
                            e.expression +
                            "' is not a function, but has to be";
                        r && (i += "Found in component '" + r + "'"), console.warn(i);
                    }
                    var o = e.modifiers.bubble,
                        a = function(n) {
                            (o || (!t.contains(n.target) && t !== n.target)) && e.value(n);
                        };
                    (t.__vueClickOutside__ = a), document.addEventListener("click", a);
                },
                unbind: function(t, e) {
                    document.removeEventListener(
                        "click",
                        t.__vueClickOutside__
                    ), (t.__vueClickOutside__ = null);
                }
            }), Vue.directive("lazy-load", {
                bind: function(e, n) {
                    e.classList.add("loading"), t.collection.util.loadImage(
                        n.value.cache,
                        n.value.src,
                        function(t) {
                            e.classList.remove("loading"), (e.style.backgroundImage =
                                "url(" + t._this.src + ")");
                        }
                    );
                },
                componentUpdated: function(e, n) {
                    e.classList.add("loading"), t.collection.util.loadImage(
                        n.value.cache,
                        n.value.src,
                        function(t) {
                            e.classList.remove("loading"), (e.style.backgroundImage =
                                "url(" + t._this.src + ")");
                        }
                    );
                }
            });
        }
    };
})(Journelle, jQuery));
(Journelle.vue.filters = (function(t, e) {
    return {
        init: function() {
            Vue.filter("money", function(t) {
                return "$" + (+t % 100 == 0 ? +t / 100 : (+t / 100).toFixed(2));
            });
        }
    };
})(0, jQuery));
(Journelle.vue.modal = (function(t, e) {
    return {
        init: function() {
            Vue.component("modal", {
                props: {
                    showClose: {
                        type: Boolean,
                        default: !1
                    },
                    open: {
                        type: Boolean,
                        default: !1
                    },
                    property: {
                        type: String
                    },
                    fullscreen: {
                        type: Boolean,
                        default: !1
                    }
                },
                methods: {
                    toggle: function(t) {
                        this.$store.commit("toggleModal", {
                            property: this.property
                        });
                    }
                },
                template: '\n                <transition name="slide">\n                    <div class="original-modal" v-if="open">\n                        <div class="original-modal__overlay" @click="toggle()"></div>\n                        <div class="original-modal__content" :class="{ fullscreen: fullscreen }">\n                            <button class="original-modal__close exempt-button"\n                                v-if="showClose"\n                                @click="toggle()">\n                            </button>\n                            <slot></slot>\n                            <button class="button--close exempt-button"\n                                v-if="showClose"\n                                @click="toggle()">\n                            </button>\n                        </div>\n                    </div>\n                </transition>\n            '
            });
        }
    };
})(0, jQuery));
(Journelle.templates.index = (function(t, e) {
    return {
        init: function() {
            t.gtm.push({
                event: "loadHome"
            });
        }
    };
})(Journelle, jQuery));
(Journelle.cart.components = (function(t, e) {
  function n(t, e, n) {
      var r = _.clone(t.product);
      _.each(e, function(t, e) {
          r[e] = t;
      }), (r.amount = 0), t.$store.commit("addGiftBox", {
          product: r
      }), t.$store.commit("addToQueue", r);
  }
  return {
      init: function() {
          t.cart.util, Vue.component("cart-header", {
              computed: {
                  cartAmount: function() {
                      return this.$store.state.products.length > 0 ? this.$store.state.products
                          .map(function(t) {
                              return t.amount;
                          })
                          .reduce(function(t, e) {
                              return t + e;
                          }) : 0;
                  }
              },
              updated: function() {
                  this.$store.state.discrete &&
                      (this.$store.state.cart.queue.push({
                          note: ""
                      }), (this.$store.state.discrete = !1));
              },
              methods: {
                  checkout: function(t) {
                      var e = e || [];
                      e.push([
                          "_trackEvent",
                          "Checkout",
                          "Button Click",
                          "cart",
                          "true"
                      ]), (window.location = t.url);
                  }
              },
              template: '<header class="cart-header"><p v-if="cartAmount == 0" class="cart-header__empty"><span class="cart-header__call-us">Questions? Call us at <a href="tel:888.885.6876"> 888.885.6876</a></span>It\'s a little lonely in here.  Check out our <a href="/collections/new"> New Arrivals</a> for some inspiration. </p><button class="cart__checkout"  @click="checkout({ url: \'/checkout\' })"  v-if="cartAmount > 0">Go To Checkout </button></header>'
          }), Vue.component("cart-items", {
              computed: {
                  products: function() {
                      return this.$store.state.products;
                  },
                  upsell: function() {
                      return this.$store.state.upsell.product;
                  },
                  cartAmount: function() {
                      return this.$store.state.products.length > 0 ? this.$store.state.products
                          .map(function(t) {
                              return t.amount;
                          })
                          .reduce(function(t, e) {
                              return t + e;
                          }) : 0;
                  },
                  plural: function() {
                      return 1 === this.cartAmount ? "item" : "items";
                  }
              },
              template: '<div v-if="cartAmount > 0" class="cart__items"><div class="cart__items-header"><span class="cart__items_amount-lbl">Your bag has {{ cartAmount }} {{ plural }}</span><span class="cart__items_quantity-lbl">Quantity</span><span class="cart__items_price-lbl">price</span></div><div class="cart__items-content"><cart-item v-for="product in products" :product="product"></cart-item><cart-upsell v-if="upsell !== null"></cart-upsell></div></div>'
          }), Vue.component("cart-item", {
              props: ["product"],
              data: function() {
                  return {
                      timeout: null,
                      inputAmount: this.product.amount,
                      error: !1,
                      errorMsg: ""
                  };
              },
              computed: {
                  image: function() {
                      return "url(" + this.product.image.mini + ")";
                  },
                  showAmount: function() {
                      return !this.product.title.toLowerCase().includes("gift");
                  },
                  url: function() {
                      if (this.showAmount) {
                          var t = this.product.url.substring(
                              this.product.url.indexOf("?"),
                              this.product.url.length
                          );
                          return (
                              window.location.origin +
                              "/products/" +
                              this.product.canonical +
                              t
                          );
                      }
                      return !1;
                  },
                  vendorHandle: function() {
                    return this.product.vendor
                        .toLowerCase()
                        .replace(/[^\w ]/g, "")
                        .replace(/ /g, "-");
                  },
                  sale: function() {
                    return this.product.sale && (!this.product.exchangesale || !this.product.full_price);
                  },
                  exchangesale: function() {
                    return (this.product.exchangesale && (!this.product.sale || this.product.full_price));
                  }
              },
              methods: {
                  updateInput: function(t) {
                      var e = this;
                      "" !== t.target.value &&
                          (this.product.amount = this.inputAmount), "" !== t.target.value &&
                          this.product.availableQuantity >= this.product.amount &&
                          (window.clearTimeout(
                              this.timeout
                          ), this.$store.commit("updateAmount", {
                              amount: this.product.amount,
                              variantId: this.product.variantId
                          }), (this.timeout = window.setTimeout(function() {
                              e.$store.commit("addToQueue", e.product);
                          }, 250))), this.product.availableQuantity >= this.product.amount ? (this.error = !1) : ((this.error = !0), (this.errorMsg =
                              "We're sorry, this item is not available in the desired quantity"));
                  },
                  updateAmount: function(t, e) {
                      var n = this;
                      void 0 === this.product.availableQuantity &&
                          (this.product.availableQuantity =
                              window.cart.gift.product.variants[0].quantity), (this.product
                              .availableQuantity >= t ||
                              0 === t ||
                              "decrease" === e) &&
                          ((this.inputAmount = t), window.clearTimeout(
                              this.timeout
                          ), this.$store.commit("updateAmount", {
                              amount: t,
                              variantId: this.product.variantId
                          }), (this.timeout = window.setTimeout(function() {
                              n.$store.commit("addToQueue", n.product);
                          }, 250))), this.product.availableQuantity >= t ? (this.error = !1) : ((this.error = !0), (this.errorMsg =
                              "We're sorry, this item is not available in the desired quantity"));
                  },
                  removeProduct: function() {
                      (this.inputAmount = 0), window.clearTimeout(
                              this.timeout
                          ), this.$store.commit("removeProduct", {
                              variantId: this.product.variantId
                          }), (this.product.amount = 0), this.product.title
                          .toLowerCase()
                          .includes("gift") &&
                          e(".cart-gift__tab").removeClass(
                              "active"
                          ), (_this = this), (this.timeout = window.setTimeout(function() {
                              _this.$store.commit("addToQueue", _this.product);
                          }, 250));
                  },
                  outOfStock: function() {
                      return (
                          this.product.amount > this.product.availableQuantity &&
                          this.product.inventoryPolicy != "continue" &&
                          0 != this.product.availableQuantity &&
                          ((this.error = !0), (this.errorMsg =
                              "We're sorry, only " +
                              this.product.availableQuantity +
                              " of this item is in-stock"), !0)
                      );
                  },
                  notAvailable: function() {
                      return (
                          0 == this.product.availableQuantity &&
                          ((this.error = !0), (this.errorMsg =
                              "We're sorry, this item is no longer available"), !0)
                      );
                  }
              },
              mounted: function() {
                  this.outOfStock(), this.notAvailable();
              },
              template: '<div class="cart-item" v-if="product.amount > 0"><a :href="url" class="cart-item__image" :class="{nopointer: !showAmount}" title="Cart Item" :style="{ backgroundImage: image }"></a> <div class="cart-item__info-wrap"><div class="cart-item__info"><a :href="\'/collections/\' + vendorHandle" class="cart-item__vendor">{{ product.vendor }}</a><a :href="url" class="cart-item__title">{{ product.title }}</a><span class="cart-item__variant" v-if="product.size.length > 0">Size: {{ product.size }}</span><span class="cart-item__variant" v-if="product.color.length > 0">Color: {{ product.color }}</span><span class="cart-item__sale" v-if="sale">Final Sale</span><span class="cart-item__sale" v-if="exchangesale">Final Sale</span></div><div class="cart-item__amount"> <div class="cart-item__input-wrap" v-if="showAmount">  <button aria-label="Decrement Quantity" class="cart-item__plus-minus cart-item__plus-minus--minus exempt-button" @click.prevent="updateAmount(product.amount - 1, \'decrease\')"></button>  <input class="cart-item__input" aria-label="Item Quantity" type="number" v-model="inputAmount" @input="updateInput"><button aria-label="Increment Quantity" class="cart-item__plus-minus cart-item__plus-minus--plus exempt-button" @click.prevent="updateAmount(product.amount + 1, \'increase\')"></button> </div><button class="cart-item__remove exempt-button" aria-label="Remove"  @click.prevent="removeProduct()">remove</button></div></div><span class="cart-item__price"><span class="cart-item__compare" v-if="product.comparePrice > product.price">{{ product.comparePrice | money }}</span><span>{{ product.price | money }}</span></span><p class="cart-item__error" v-show="error">{{ errorMsg }}</p></div>'
          }), Vue.component("cart-upsell", {
              data: function() {
                  return {
                      dropdownActive: !1
                  };
              },
              computed: {
                  hasProducts: function() {
                      return (
                          this.$store.state.products.length > 0 &&
                          this.$store.state.products
                          .map(function(t) {
                              return t.amount;
                          })
                          .reduce(function(t, e) {
                              return t + e;
                          }) > 0
                      );
                  },
                  message: function() {
                      return this.$store.state.upsell.message;
                  },
                  product: function() {
                      return this.$store.state.upsell.product;
                  },
                  inCart: function() {
                      var t = this;
                      return (
                          this.$store.state.products.filter(function(e) {
                              return e.productId === t.product.productId && e.amount > 0;
                          }).length > 0
                      );
                  },
                  image: function() {
                      return "url(" + this.product.image.mini + ")";
                  }
              },
              methods: {
                  addToBag: function(t) {
                      this.product.variants.length > 1 ? ((this.dropdownActive = !this.dropdownActive), t && n(this, t)) : n(this, this.product.variants[0]);
                  },
                  closeDropdown: function() {
                      this.dropdownActive = !1;
                  }
              },
              template: '\n                <section class="cart-upsell" v-if="!inCart && hasProducts">\n                    <h5 class="cart-upsell__heading-wrap"><span class="cart-upsell__heading">{{ message }}</span></h5>\n                    <div class="cart-upsell__image" :style="{ backgroundImage: image }"></div>\n                    <div class="cart-upsell__info">\n                        <span class="cart-upsell__title">{{ product.title }}</span>\n                        <span class="cart-upsell__price">{{ product.price | money }}</span>\n                    </div>\n                    <div class="cart-upsell__add" v-click-outside="closeDropdown">\n                        <button class="cart-upsell__button exempt-button"\n                            @click="addToBag()">+ Add to Bag</button>\n                        <div class="cart-upsell__dropdown"\n                            :class="{ active: dropdownActive }"\n                            v-if="product.variants.length > 1">\n                            <span class="cart-upsell__dropdown-item"\n                                v-for="variant in product.variants"\n                                @click="addToBag(variant)">\n                                {{ variant.size }}\n                            </span>\n                        </div>\n                    </div>\n                </section>\n            '
          }), Vue.component("cart-gift", {
              data: function() {
                  return {
                      active: !1
                  };
              },
              computed: {
                  hasProducts: function() {
                      return (
                          this.$store.state.products.length > 0 &&
                          this.$store.state.products
                          .map(function(t) {
                              return t.amount;
                          })
                          .reduce(function(t, e) {
                              return t + e;
                          }) > 0
                      );
                  },
                  inCart: function() {
                      var t = this;
                      return (
                          this.product &&
                          this.$store.state.products.filter(function(e) {
                              return e.productId === t.product.productId && e.amount > 0;
                          }).length > 0
                      );
                  },
                  gift: function() {
                      return this.$store.state.gift;
                  },
                  product: function() {
                      return this.gift.product;
                  },
                  image: function() {
                      return "url(" + this.product.image.mini + ")";
                  }
              },
              methods: {
                  addToBag: function() {
                      this.$store.state.discrete ? this.$store.commit("updateNote", {
                          note: "|DISCRETE PACKAGING"
                      }) : this.$store.commit("updateNote", {
                          note: ""
                      }), n(
                          this,
                          this.product.variants[0]
                      );
                  },
                  toggleTab: function() {
                      this.active && !e(".cart-gift__tab").hasClass("active") ? e(".cart-gift__tab").addClass("active") : this.active ? (this.active = !1) : (this.active = !0);
                  }
              },
              template: '<section class="cart-gift__tab cart-accordian__item" :class="{ active: active }"><button class="cart-accordian__title exempt-button" @click.prevent="toggleTab()"><span class="cart-accordian__icon"></span><span v-show="inCart">gift message </span> <span v-show="!inCart">{{ gift.heading }} </span></button><div class="cart-accordian__content rte"><div class="cart-accordian__inside"><cart-gift-message></cart-gift-message><div class="cart-gift" v-if="hasProducts && !inCart"><div class="cart-gift__image" :style="{ backgroundImage: image }"></div><div class="cart-gift__info"><p class="cart-gift__message">{{ gift.message }}</p><span class="cart-gift__add" @click.prevent="addToBag()">Add a gift box for {{ gift.product.price | money }}</span></div></div></div></div></section>'
          }), Vue.component("cart-gift-message", {
              data: function() {
                  return {
                      message: this.$store.state.note.replace("|DISCRETE PACKAGING", "")
                  };
              },
              computed: {
                  inCart: function() {
                      var t = this;
                      return (
                          this.product &&
                          this.$store.state.products.filter(function(e) {
                              return e.productId === t.product.productId && e.amount > 0;
                          }).length > 0
                      );
                  },
                  gift: function() {
                      return this.$store.state.gift;
                  },
                  product: function() {
                      return this.gift.product;
                  },
                  updateMessage: function() {
                      var t = new RegExp("\\|DISCRETE PACKAGING", "g");
                      return (this.message = this.$store.state.note.replace(t, "")), !0;
                  },
                  messaging: function() {
                      return this.$store.state.note.length ? "|DISCRETE PACKAGING" === this.$store.state.note ? "Add" : "Update" : "Add";
                  }
              },
              methods: {
                  updateNote: function() {
                      this.$store.state.discrete ? this.$store.commit("updateNote", {
                          note: this.message + "|DISCRETE PACKAGING"
                      }) : this.$store.commit("updateNote", {
                          note: this.message
                      });
                  }
              },
              template: '<transition name="fade"><div class="cart-gift__note" v-if="inCart"><textarea v-if="updateMessage" name="gift-note" id="gift-note" class="cart-gift__note-text" maxlength="250" v-model="message"></textarea><button class="cart-gift__add exempt-button" @click.prevent="updateNote()">{{ messaging }} gift message </button></div></transition>'
          }), Vue.component("cart-order-summary", {
              data: function() {
                  return {
                      cssClass: ""
                  };
              },
              computed: {
                  cartAmount: function() {
                      return this.$store.state.products.length > 0 ? this.$store.state.products
                          .map(function(t) {
                              return t.price * t.amount;
                          })
                          .reduce(function(t, e) {
                              return t + e;
                          }) : 0;
                  },
                  cart: function() {
                      return this.$store.state.cart;
                  },
                  shippingValue: function() {
                      return this.cartAmount < 100 * this.$store.state.threshold ? ((this.cssClass = ""), "TBD") : ((this.cssClass = "free-lbl"), "Free");
                  }
              },
              methods: {
                  checkout: function(t) {
                      var e = e || [];
                      e.push([
                          "_trackEvent",
                          "Checkout",
                          "Button Click",
                          "cart",
                          "true"
                      ]), (window.location = t.url);
                  }
              },
              mounted: function() {
                if (window.affirm) {
                    affirm.ui.ready(function() {
                        affirm.ui.refresh();
                    });
                }
              },
              updated: function() {
                if (window.affirm) {
                    affirm.ui.ready(function() {
                        affirm.ui.refresh();
                    });
                }
              },
              template: '<div v-if="cartAmount > 0"  class="cart__order-summary"><span class="cart-header__call-us">Questions? Call us at <a href="tel:888.885.6876"> 888.885.6876</a></span><h4 class="cart__order-summary-title">Order Summary</h4><ul><li>Subtotal <span class="cart__subtotal">{{ cartAmount | money }}</span></li><li>Shipping <span :class="cssClass" class="cart__shipping"> {{shippingValue}} </span></li><li>Tax <span class="cart__tax"> TBD</span></li><li>Total <span class="cart__total">{{ cartAmount | money }}</span></li><li>Financing <span class="affirm-as-low-as" data-page-type="cart" :data-amount="cartAmount"></span></li></ul><button class="cart__checkout"  @click="checkout({ url: \'/checkout\' })"  v-if="cartAmount > 0">Go To Checkout </button><p>Proceed to checkout to enter a promo code</p></div>'
          }), Vue.component("cart-accordian", {
              data: function() {
                  return {
                      giftOpen: !1
                  };
              },
              computed: {
                  cartAmount: function() {
                      return this.$store.state.products.length > 0 ? this.$store.state.products
                          .map(function(t) {
                              return t.price * t.amount;
                          })
                          .reduce(function(t, e) {
                              return t + e;
                          }) : 0;
                  },
                  cart: function() {
                      return this.$store.state.cart;
                  },
                  gift: function() {
                      return this.$store.state.gift;
                  },
                  inCart: function() {
                      var t = this;
                      return (
                          this.gift.product &&
                          this.$store.state.products.filter(function(e) {
                              return e.productId === t.gift.product.productId && e.amount > 0;
                          }).length > 0
                      );
                  },
                  productSkus: function() {
                      return this.$store.state.products.map(function(t) {
                          return t.sku;
                      });
                  }
              },
              methods: {
                  openGift: function() {
                      this.giftOpen = !0;
                  }
              },
              mounted: function() {
                  this.inCart && (this.giftOpen = !0);
              },
              template: '<div v-if="cartAmount > 0" class="cart-accordian"><cart-gift v-if="gift.product"></cart-gift><cart-discrete-packaging></cart-discrete-packaging><shipping-and-returns></shipping-and-returns></div>'
          }), Vue.component("cart-discrete-packaging", {
              data: function() {
                  return {
                      active: !1,
                      checked: this.$store.state.discrete
                  };
              },
              computed: {
                  discreteMessage: function() {
                      return this.$store.state.discreteMessage;
                  },
                  cart: function() {
                      return this.$store.state.cart;
                  },
                  checkboxClass: function() {
                      return this.checked ? "checked" : "";
                  }
              },
              methods: {
                  toggleTab: function() {
                      this.active = !this.active;
                  },
                  toggleDiscreteNote: function() {
                      this.$store.commit("toggleDiscreteNote", {
                          note: this.$store.state.note,
                          discrete: this.$store.state.discrete
                      });
                  }
              },
              template: '<section class="cart-discrete cart-accordian__item" :class="{ active: active }"><button class="cart-accordian__title exempt-button" @click.prevent="toggleTab()"><span class="cart-accordian__icon"></span><span v-show="!checked">REQUEST DISCREET PACKAGING</span> <span v-show="checked">ORDER SHIPS IN DISCREET PACKAGING</span></button><div class="cart-accordian__content rte"><div class="cart-accordian__inside"><p class="cart-discrete__message">{{ discreteMessage }}</p><label class="checkbox-label" :class="checkboxClass"><input type="checkbox" v-model="checked" @click="toggleDiscreteNote()" name="discrete" /><span class="checkmark"></span><span class="text">Use discreet packaging</span></label></div></div></section>'
          }), Vue.component("shipping-and-returns", {
              data: function() {
                  return {
                      active: !1
                  };
              },
              computed: {},
              methods: {
                  toggleTab: function() {
                      this.active = !this.active;
                  }
              },
              template: '<section class="cart-returns cart-accordian__item" :class="{ active: active }"><button class="cart-accordian__title exempt-button" @click.prevent="toggleTab()"><span class="cart-accordian__icon"></span>Shipping & Returns</button><div class="cart-accordian__content rte">' +
                  window.product.shippingandreturns +
                  "</div></section>"
          });
      }
  };
})(Journelle, jQuery));
(Journelle.templates.product = (function(t, e) {
    return {
        init: function() {
            var n = t.product.store,
                r = (
                    t.vue.filters.init(),
                    t.vue.directives.init(),
                    t.product.components.init(),
                    t.vue.modal.init(),
                    new Vue({
                        el: "#cart-modal",
                        store: n,
                        computed: {
                            active: function() {
                                return this.$store.state.alert.active;
                            },
                            product: function() {
                                return this.$store.state.alert.product;
                            },
                            productThumb: function() {
                                if (this.$store.state.alert.product.image)
                                    return this.$store.state.alert.product.image.thumb;
                            }
                        },
                        created: function() {
                            var t = this;
                            e("#overlay").click(function() {
                                t.$store.commit("closeModal");
                            });
                        },
                        methods: {
                            closeModal: function() {
                                this.$store.commit("closeModal");
                            }
                        },
                         template: '<div class="cart-modal" :class="{ active: active }" id="cart_modal_popup"><div class="cart-modal__header">A lovely was added to your bag!<span class="cart-modal__close" @click="closeModal()"> X </span></div><div class="cart-modal__body"><div class="cart-modal__thumb"><img :src="productThumb" alt="" /></div><div class="cart-modal__info"><span class="cart-modal__title">{{ product.title }}</span><span class="cart-modal__color">Color: {{ product.color }}</span><span class="cart-modal__size">Size: {{ product.size }}</span></div><div class="cart-modal__buttons"><a href="/checkout" class="button cart-modal__open checkoutBtn">Go To Checkout</a><a href="/cart" class="button secondary cart-modal__open">View Shopping Bag</a> <button class="button secondary cart-modal__continue" @click.prevent="closeModal()">Continue Shopping</button> </div></div><div class="cart-modal__footer"><modal-wear-with></modal-wear-with></div></div>'
                   }),
                    new Vue({
                        el: "#product",
                        name: 'ProductPage',
                        store: n,
                        computed: {
                            activeProduct: function() {
                                return this.$store.state.product.products.filter(function(t) {
                                    return t.active;
                                })[0];
                            },
                            isMobile: function() {
                                return this.$store.state.settings.isMobile;
                            },
                            openModel: function() {
                                return this.$store.state.modal.sizingOpen;
                            },
                            restockOpenModal: function() {
                                return this.$store.state.modal.restockOpen;
                            }
                        },
                        created: function() {
                            var e = this;
                            this.activeProduct.images.forEach(function(n) {
                                t.collection.util.loadImage(
                                    e.$store.state.imageCache,
                                    n.regular,
                                    function(t) {
                                        t.cached || e.$store.commit("cacheImage", t._this);
                                    }
                                ), t.collection.util.loadImage(
                                    e.$store.state.imageCache,
                                    n.mini,
                                    function(t) {
                                        t.cached || e.$store.commit("cacheImage", t._this);
                                    }
                                );
                            }), history.replaceState({
                                    product: !0,
                                    title: this.activeProduct.title,
                                    productId: this.activeProduct.productId
                                },
                                this.activeProduct.title,
                                window.location.href
                            );
                        },
                        mounted: function() {
                            var e = this;
                            window.addEventListener(
                                    "resize",
                                    _.throttle(function(t) {
                                        e.$store.commit("setIsMobile", {
                                            width: document.documentElement.clientWidth
                                        });
                                    }, 16)
                                ), this.$store.state.product.products
                                .filter(function(t) {
                                    return !t.active;
                                })
                                .forEach(function(n) {
                                    n.images.forEach(function(n) {
                                        t.collection.util.loadImage(
                                            e.$store.state.imageCache,
                                            n.regular,
                                            function(t) {
                                                t.cached || e.$store.commit("cacheImage", t._this);
                                            }
                                        ), t.collection.util.loadImage(
                                            e.$store.state.imageCache,
                                            n.mini,
                                            function(t) {
                                                t.cached || e.$store.commit("cacheImage", t._this);
                                            }
                                        );
                                    });
                                });

                            // Google Tag AW-1031464577 - Product Page View event.
                            // Variant data to get SKU
                            // var variantData = this.$store.state.product.products.filter(function(product) {
                            //     return product.variants
                            // });
                            // var ecomm_prodid = [];
                            // for(var i=0;i<variantData.length;i++) {
                            //     ecomm_prodid.push(variantData[i].sku);
                            // }

                            var ecomm_prodid = []
                            var bundle = this.$store.state.product.products[0].named_tags.bundle;
                            ecomm_prodid.push(bundle);
                            if(window.google_tag_params) {
                                gtag('event', 'page_view', {
                                    'send_to': 'AW-1031464577',
                                    'ecomm_prodid': ecomm_prodid,
                                    'ecomm_pagetype': window.google_tag_params.ecomm_pagetype,
                                    'ecomm_totalvalue':window.google_tag_params.ecomm_totalvalue
                                  });
                            } else {
                                gtag('event', 'page_view', {
                                    'send_to': 'AW-1031464577',
                                    'ecomm_prodid': ecomm_prodid,
                                    'ecomm_pagetype': 'product',
                                    'ecomm_totalvalue': window.productDatalayer.price / 100,
                                });
                            }
                        },
                        template: '<div class="product"> <product></product><modal :showClose="false"  :open="restockOpenModal" property="restockOpen"> <notify-me></notify-me></modal><modal :showClose="true" :open="openModel" property="sizingOpen"  :fullscreen="true"> <sizing></sizing></modal></div>'
                    })
                );
            window.onpopstate = function(t) {
                void 0 !== t.state.product &&
                    r.$store.commit("updateProduct", {
                        product: {
                            productId: t.state.productId
                        }
                    });
            };
            var i = t.product.store.state.product.products.filter(function(t) {
                return t.active;
            })[0].productId;
            t.gtm.push({
                event: "loadPDP",
                parentProductId: i
            }, {
                baseProduct: window.product.products[0].sku
            });
          /* Listrak Code Start */
          /*var mainUrl = document.URL;
          //var pp = t.product.store.state.product.products.filter(function(t) {return t.active;})[0];
          var pp = window.product.products[0];
          var sku = pp.productId;
          var qoh = pp.inventory_quantity;
          var price = document.querySelector('.page-header .product-info__price').innerHTML;
          var r = pp.named_tags["images"].split("|"); 
          var mainImg = r[0];
          var pid = pp.named_tags["product-id"];
          var cid = pp.named_tags["color-code"];
          var title = pp.title;
          var imageUrl = "https://s7d2.scene7.com/is/image/Journelle/" + pid +"-" +cid+ "-" + mainImg+"?$pdp$";
          (function(d){if(typeof _ltk=="undefined"){if(document.addEventListener)document.addEventListener("ltkAsyncListener",function(){_ltk_util.ready(d)});else{e=document.documentElement;e.ltkAsyncProperty=0;e.attachEvent("onpropertychange",function(e){if(e.propertyName=="ltkAsyncProperty"){_ltk_util.ready(d)}})}}else{_ltk_util.ready(d)}})(function(){
           document.addEventListener('browse2',function(){
            _ltk.Activity.AddProductBrowse(sku.toString(),{ImageURL:imageUrl,mainUrl:mainUrl,quantity:qoh,title:title,price:price});
            });
          });*/
          /* Listrak Code End */
        }
    };
})(Journelle, jQuery));
(Journelle.collection.util = (function(t, e) {
    function n(t) {
        return t ? decodeURI(t).replace("?", "").split("&").map(function(t) {
            if (t.indexOf("=") > -1)
                return {
                    name: (t = t.split("="))[0],
                    tags: t[1].split("|")
                };
        }) : [];
    }
    return {
        loadImage: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                e = arguments[1],
                n = arguments[2];
            if ("string" == typeof e) {
                var r = t.filter(function(t) {
                    return (
                        t.src.replace(/^https?\:/i, "") === e.replace(/^https?\:/i, "")
                    );
                });
                if (r.length > 0)
                    return _.isFunction(n) && n({
                        cached: !0,
                        _this: r[0]
                    }), !0;
                var i = document.createElement("img");
                return i.addEventListener("load", function() {
                    _.isFunction(n) &&
                        n({
                            _this: this
                        }), this.removeEventListener("load", this);
                }), i.setAttribute("src", e), !0;
            }
            return !1;
        },
        toggleTag: function(t, e, r) {
            var i = "?",
                o = [];
            return t &&
                (o = n(t)).filter(function(t) {
                    return t.name === e;
                }).length > 0 ? (o = o
                    .map(function(t) {
                        return t.name === e &&
                            (_.contains(t.tags, r) ? (t.tags = t.tags.filter(function(t) {
                                    return t !== r;
                                })) : "sort_by" === e ||
                                "type" === e ||
                                "subcategory" === e ||
                                "q" === e ? (t.tags = [r]) : t.tags.push(r)), t;
                    })
                    .filter(function(t) {
                        return !("type" === e && "subcategory" === t.name);
                    })) : o.push({
                    name: e,
                    tags: [r]
                }), o.forEach(function(t) {
                    t.tags.length > 0 && (i += t.name + "=" + t.tags.join("|") + "&");
                }), i.slice(0, -1);
        },
        getSearch: n,
        clearTags: function(t, e) {
            var r = "?",
                i = n(t).filter(function(t) {
                    return t.name === e;
                })[0];
            return i &&
                i.tags.length > 0 &&
                (r += i.name + "=" + i.tags.join("|") + "&"), r.slice(0, -1);
        },
        addTempFilters: function(t, e, n) {
            t.forEach(function(t) {
                var r = !1;
                (t.tempItems = _.chain(e.products)
                    .map(function(e) {
                        return e.map(function(e) {
                            return e[t.filterBy];
                        });
                    })
                    .flatten()
                    .uniq()
                    .filter(function(e) {
                        return (
                            "price" !== t.filterBy &&
                            t.items.filter(function(t) {
                                return t.name === e || t.name.toLowerCase() === e.toLowerCase();
                            }).length <= 0
                        );
                    })
                    .value()
                    .map(function(t) {
                        return {
                            name: t,
                            active: !1,
                            image: null
                        };
                    })
                    .map(function(t) {
                        return _.isArray(n) &&
                            _.contains(n, t.name.toLowerCase()) &&
                            ((t.active = !0), (r = !0)), t;
                    })), t.items.forEach(function(t) {
                    _.contains(n, t.name.toLowerCase()) && ((t.active = !0), (r = !0));
                }), r && (t.active = !0);
            });
        },
        isBraSizing: function(t) {
            var e = +t.split(/[a-zA-Z]+/).filter(function(t) {
                return "" !== t;
            })[0];
            return e > 20 && e < 60;
        },
        returnParam: function(t, e) {
            return t ? decodeURI(t)
                .replace("?", "")
                .split("&")
                .map(function(t) {
                    return t.indexOf("=") > -1 && (t = t.split("="))[0] === e ? t[1] : "";
                })
                .filter(function(t) {
                    return "" !== t;
                })
                .shift() : "";
        }
    };
})(0, jQuery));
(Journelle.sections.footer = (function(t, e) {
    var n = 680,
        r = window.innerWidth;
    return {
        init: function() {

          $(".js-footer-trigger").on("click", function(e) {
              e.stopPropagation(), r < n && this.classList.toggle("open");
          });
          $(window).on("resize",
              _.debounce(function() {
                  r = window.innerWidth;
              }, 250)
          );

          $(".js-footer-subscribe")
          .on("submit", function(e) {
              e.preventDefault();
              var $newsletterInput = $(this).find("#footer-email");
              var $newsletterSuccess = $(this).find(".js-footer-email-message-success");
              var $newsletterFailure = $(this).find(".js-footer-email-message-success");

              $newsletterInput.prop('disabled', true);

              t.newsletter.add(
                  $newsletterInput.val(),
                  function(response) {
                      $newsletterSuccess.removeClass("hidden");
                  },
                  function(response) {
                      $newsletterFailure.removeClass("hidden");
                  }
              );
          });
        }
    };
})(Journelle, jQuery));

var allBandSizes = [],
    allCupSizes = [],
    fillCanonicalProducts = function(t, e) {
        var n = [];
        if (void 0 != e["options.color"]) {
            var r = e["options.color"];
            for (key in r)
                n.push(key);
        }
        var i = [];

        // Since some products don't have the proper tags in the first iteration,
        // we'll create a temporary array for any products that also have the 'cup-size' tag.
        // We'll also store the index of each element that might need to be replaced if we find any products with the
        // 'cup-size' tag.
        // That way, if we find array elements with the 'cup-size' tag that are further down the list, and are skipped by the first loop,
        // we can replace them with the proper elements instead.
        var tempArrayWithCupSize = [];
        var tempArrayIndexesToReplace = [];

        n.forEach(function(e) {
            for (var n = 0; n < t.length; n++) {
                if (t[n].options && t[n].options.color === e) {
                    i.push(t[n]);

                    // save the index of this product, just in case we need to replace it with a cup-size tagged variant.
                    // this loop runs multiple times, so we can't just clear the variant array, since there might be valid variants
                    // found by the first loop, which doesn't check for the 'cup-size' tag.
                    tempArrayIndexesToReplace.push(i.length - 1);
                    break;
                }
            }

            // loop through all variants and find the ones that also have the 'cup-size' tag
            for (var n = 0; n < t.length; n++) {
                if (t[n].options && t[n].options.color === e && t[n].named_tags['cup-size']) {
                    tempArrayWithCupSize.push(t[n]);
                    break;
                }
            }

            // if we found any products with a cup size, use those instead.
            if (tempArrayWithCupSize.length) {
                // loop through the temporary array of variants
                for (var index = 0; index < tempArrayWithCupSize.length; index++) {
                    // get the element at the variant array index that we're going to replace, and replace it with the cup-size tagged variant.
                    i[tempArrayIndexesToReplace[index]] = tempArrayWithCupSize[index];
                }
            }
        });
        var o = getUrlParam("variant"),
            a = getUrlParam("color");
        i.forEach(function(e, n) {
            for (record in e) {
                if (
                    ("id" === record &&
                        ((e.productId = e.id), delete e.id), "compare_at_price" ===
                        record &&
                        ((e.comparePrice =
                            e.compare_at_price), delete e.compare_at_price), "options" ===
                        record)
                )
                    for (option in e.options)
                        "color" === option && (e.color = e.options.color);
                if ("named_tags" === record)
                    for (tag in e.named_tags)
                        "material-type" === tag &&
                        (e.material = e.named_tags[tag]), "band-size" === tag &&
                        (e.bandSize = e.named_tags[tag]), "cup-size" === tag &&
                        (e.cupSize = e.named_tags[tag]), "base-color" === tag &&
                        (e.baseColor = e.named_tags[tag]), "custom-tag" === tag &&
                        (e.named_tags[tag].indexOf("new arrivals") >= 0 ? (e.new = !0) : (e.new = !1)), "color-code" === tag &&
                        (e.color_code = e.named_tags[tag]), "color-hex" === tag &&
                        (e.colorHex = e.named_tags[tag]);
                if (
                    ("body_html_safe" === record &&
                        (e.description = ('<p class="pdp-description">' + e.body_html_safe + '</p>')), "_highlightResult" === record)
                )
                    for (tag in e._highlightResult)
                        "product_type" === tag &&
                        (e.type = e._highlightResult.product_type);
            }

            if (window.product_description) {
                e.description = window.product_description;
            }

            var r;
            if (
                ((e.comparePrice = 100 * e.comparePrice), (e.price = 100 * e.price), e
                    .named_tags.images)
            ) {
                (e.imageCodes = []), (e.images = []), (r = e.named_tags.images.split(
                    "|"
                ));
                for (i in r)
                    e.imageCodes.push(r[i]), e.images.push({
                        thumb: "https://s7d2.scene7.com/is/image/Journelle/" +
                            e.named_tags["product-id"] +
                            "-" +
                            e.color_code +
                            "-" +
                            r[i] +
                            "?$pdp$",
                        mini: "https://s7d2.scene7.com/is/image/Journelle/" +
                            e.named_tags["product-id"] +
                            "-" +
                            e.color_code +
                            "-" +
                            r[i] +
                            "?$thumb$",
                        small: "https://s7d2.scene7.com/is/image/Journelle/" +
                            e.named_tags["product-id"] +
                            "-" +
                            e.color_code +
                            "-" +
                            r[i] +
                            "?$wear-with$",
                        regular: "https://s7d2.scene7.com/is/image/Journelle/" +
                            e.named_tags["product-id"] +
                            "-" +
                            e.color_code +
                            "-" +
                            r[i] +
                            "?$pdp$",
                        active: 0 == i
                    });
            } else(e.images = []), e.images.push({
                thumb: imageURL(e.image, "_40x"),
                mini: imageURL(e.image, "_200x"),
                small: imageURL(e.image, "_1000x"),
                regular: imageURL(e.image, "_2000x"),
                active: !0
            });
            if (r) {
                var i;
                (i = e.imageCodes.indexOf("z") >= 0 ? "z" : r[0]), (e.image = {
                    thumb: "https://s7d2.scene7.com/is/image/Journelle/" +
                        e.named_tags["product-id"] +
                        "-" +
                        e.color_code +
                        "-" +
                        i +
                        "?$thumb$",
                    mini: "https://s7d2.scene7.com/is/image/Journelle/" +
                        e.named_tags["product-id"] +
                        "-" +
                        e.color_code +
                        "-" +
                        i +
                        "?$wear-with$",
                    regular: "https://s7d2.scene7.com/is/image/Journelle/" +
                        e.named_tags["product-id"] +
                        "-" +
                        e.color_code +
                        "-" +
                        i +
                        "?$pdp$"
                });
            } else {
                var s = e.image;
                e.image = {
                    thumb: imageURL(s, "_40x"),
                    mini: imageURL(s, "_200x"),
                    regular: imageURL(s, "_800x"),
                    active: !0
                };
            }
            e.variants = [];
            var c = !1;
            if (
                (t.forEach(function(t) {
                    (e.options && e.options.color) === (t.options && t.options.color) &&
                        ((c = o === t.objectID), e.variants.push({
                            active: c,
                            price: 100 * t.price,
                            quantity: t.inventory_quantity,
                            size: t.options && t.options.size,
                            url: "/products/" +
                                t.named_tags.canonical +
                                "?variant=" +
                                t.objectID,
                            variantId: t.objectID
                        }));
                }), null != o)
            ) {
                var u = !1;
                e.variants.forEach(function(t) {
                    t.variantId === o && (u = !0);
                }), (e.active = u), u && (window.family = e.named_tags.family);
            } else null != a ? (e.color_code == a ? ((e.active = !0), (window.family = e.named_tags.family)) : (e.active = !1)) : 0 === n ? ((window.family = e.named_tags.family), (e.active = !0)) : (e.active = !1);

            if (
                e.cupSize &&
                "[object Array]" != Object.prototype.toString.call(e.cupSize)
            ) {
                var l = e.cupSize;
                (e.cupSize = []), e.cupSize.push(l);
            }
            if (
                e.bandSize &&
                "[object Array]" != Object.prototype.toString.call(e.bandSize)
            ) {
                l = e.bandSize;
                (e.bandSize = []), e.bandSize.push(l);
            }
            e.cupSize &&
                (e.cupSize.forEach(function(t) {
                    allCupSizes.push(t);
                }), (allCupSizes = uniqValues(
                    allCupSizes
                )), e.bandSize.forEach(function(t) {
                    allBandSizes.push(t);
                }), (allBandSizes = uniqValues(
                    allBandSizes
                ))), (e.careandcontents = window.product.settings.tabs[1].content), (e.shippingandreturns = window.product.shippingandreturns[0]), window.product.products.push(e);
        });
        for (var s = !1, c = 0; c < i.length; c++)
            if (i[c].active) {
                s = !0;
                break;
            }
        s ||
            (null != o &&
                null != a &&
                i.forEach(function(t, e) {
                    t.color_code == a ? ((t.active = !0), (window.family = t.named_tags.family), (s = !0)) : (t.active = !1);
                }), s ||
                ((i[0].active = !0), (window.family = i[0].named_tags.family)));
    },
    imageURL = function(t, e) {
        if (!t) {
            return '';
        }
        var n = t.lastIndexOf(".");
        return t.slice(0, n) + e + "." + t.slice(n + 1);
    },
    uniqValues = function(t) {
        for (var e = {}, n = [], r = t.length, i = 0, o = 0; o < r; o++) {
            var a = t[o];
            1 !== e[a] && ((e[a] = 1), (n[i++] = a));
        }
        return n;
    },
    getUrlParam = function() {
        var t = !1,
            e = {},
            n = null,
            r = location.search.substring(1);
        arguments.length > 0 && arguments[0].length > 1 && (t = arguments[0]);
        for (var i = /([^&=]+)=([^&]*)/g;
            (n = i.exec(r));) {
            if (!1 !== t && decodeURIComponent(n[1]) === t)
                return decodeURIComponent(n[2]);
            !1 === t && (e[decodeURIComponent(n[1])] = decodeURIComponent(n[2]));
        }
        return !1 === t ? e : null;
    },
    setUrlParam = function(t, e) {
        (t = escape(t)), (e = escape(e));
        var n = document.location.href.split("?")[0],
            r = document.location.search.substr(1).split("&");
        if ("" == r) n += "?" + t + "=" + e;
        else {
            for (var i, o = r.length; o--;)
                if ((i = r[o].split("="))[0] == t) {
                    (i[1] = e), (r[o] = i.join("="));
                    break;
                }
            o < 0 && (r[r.length] = [t, e].join("=")), (n += "?" + r.join("&"));
        }
        return n;
    };

function addProductSchema(t, e) {
    var n = $("meta[name='description']")[0].content,
        r = document.createElement("script");
    r.type = "application/ld+json";
    var i = "",
        o = [];
    if (t) {
        i = "http://schema.org/InStock";
        for (var a = 0; a < e.images.length; a++)
            o.push(e.images[a].mini);
    } else i = "http://schema.org/SoldOut";
    var s = {
        "@context": "http://schema.org/",
        "@type": "Product",
        name: window.sProducts[0].title,
        image: o,
        description: n,
        brand: {
            "@type": "Thing",
            name: window.sProducts[0].vendor
        },
        offers: {
            "@type": "Offer",
            priceCurrency: "USD",
            price: window.sProducts[0].price / 100,
            itemCondition: "http://schema.org/NewCondition",
            availability: i,
            seller: {
                "@type": "Organization",
                name: "Journelle"
            }
        }
    };
    (r.text = JSON.stringify(s)), document.querySelector("head").appendChild(r);
}

(Journelle.templates.cart = (function(t, e) {
  return {
      init: function() {
          var e = t.cart.store;
          t.vue.filters.init(), t.vue.directives.init(), t.cart.components.init(), new Vue({
              el: "#cart",
              store: e,
              computed: {
                  active: function() {
                      return this.$store.state.cart.active;
                  }
              },
              template: '<div class="cart" :class="{ active: active }"><cart-header></cart-header><section class="cart__content"><cart-items></cart-items></section><section class="cart__side-content"><cart-order-summary></cart-order-summary><cart-accordian></cart-accordian></section><div class="cart__overlay"></div></div>'
          });
      }
  };
})(Journelle, jQuery));

(Journelle.cart.util = (function(t, e) {
    return {
        update: function(t) {
            return new Promise(function(e, n) {
                RC.cart.update(
                    t,
                    function(t) {
                        e(t);
                    },
                    function(t) {
                        n(t);
                    }
                );
            });
        }
    };
})(0, jQuery));
(Journelle.cart.store = (function(t, $) {
    if (window.cart) {
        document.body;
        var cartUtil = t.cart.util,
            r = new Vuex.Store({
                state: {
                    cart: {
                        active: !1,
                        emptyMessage: window.cart.emptyMessage,
                        emptyUrl: window.cart.emptyUrl,
                        emptyButtonText: window.cart.emptyButtonText,
                        queueActive: !1,
                        queue: []
                    },
                    upsell: {
                        message: window.cart.upsellMessage,
                        product: window.cart.upsellProduct
                    },
                    gift: window.cart.gift,
                    note: window.cartNote,
                    threshold: window.cart.cartThreshold,
                    discrete: -1 !== window.cartNote.indexOf("|DISCRETE PACKAGING"),
                    products: window.cartData,
                    discreteMessage: window.discreteMessage,
                    wearWith: []
                },
                mutations: {
                    addToQueue: function(t, e) {
                        var n = t.cart.queue.filter(function(t) {
                            return t.variantId === e.variantId;
                        });
                        n.length > 1 ? (n[1].amount = e.amount) : t.cart.queue.push(e);
                    },
                    updateAmount: function(t, e) {
                        t.products.filter(function(t) {
                                return t.variantId === e.variantId;
                            })[0].amount =
                            e.amount;
                    },
                    addProduct: function(t, e) {
                        var n = t.products.filter(function(t) {
                            return t.variantId === e.product.variantId;
                        });
                        n.length > 0 ? n[0].amount++
                            : (e.product.amount++, t.products.push(
                                e.product
                            )), addToCartDataLayer(e.product);
                    },
                    addGiftBox: function(t, e) {
                        e.product.amount++, t.products.push(e.product), addToCartDataLayer(
                            e.product
                        );
                    },
                    removeProduct: function(t, e) {
                        t.products.filter(function(t) {
                            return t.variantId === e.variantId;
                        })[0].amount = 0;
                    },
                    updateRequests: function(t, e) {
                        t.cart.requests;
                    },
                    updateNote: function(t, e) {
                        t.cart.queue.push({
                            note: e.note
                        }), (t.note = e.note);
                    },
                    toggleDiscreteNote: function(t, e) {
                        if (t.discrete) {
                            var n = new RegExp("\\|DISCRETE PACKAGING", "g");
                            t.note = t.note.replace(n, "");
                        } else t.note = t.note + "|DISCRETE PACKAGING";
                        t.cart.queue.push({
                            note: t.note
                        }), (t.discrete = !t.discrete);
                    }
                }
            });
        return r.watch(
            function() {
                return r.state.cart.queue;
            },
            function() {
                if (!r.state.cart.queueActive) {
                    var t = r.state.cart.queue;
                    if (t.length > 0) {
                        var e = {};
                        t[0].hasOwnProperty("note") ? (e.note = t[0].note) : ((e.updates = {}), (e.updates[t[0].variantId] =
                                t[0].amount)), (r.state.cart.queueActive = !0), cartUtil.update(e)
                            .then(function(e) {
                              (r.state.cart.queueActive = !1), t.shift();
                              // update cart icon
                              var cartQuantity = r.state.products
                                  .map(function(t) {
                                      return t.amount;
                                  })
                                  .reduce(function(t, e) {
                                      return t + e;
                                  })
                              if (cartQuantity > 0 ){
                                  $('.cart-item-count').text(cartQuantity);
                                  $('.header-tools-cart').addClass('cart-has-content');
                              } else {
                                  $('.cart-item-count').text();
                                  $('.header-tools-cart').removeClass('cart-has-content');
                              }
                            })
                            .catch(function(e) {
                                console.log(e), (r.state.cart.queueActive = !1), t.shift();
                            });
                    }
                }
            }
        ), r;
    }
    return {};
})(Journelle, jQuery));
(Journelle.product.util = (function(t, e) {
    return {
        keepInRange: function(t, e, n) {
            return Math.min(Math.max(parseInt(t), e), n);
        },
        correctAngles: function(t) {
            return (t = Math.abs(t)), (parseFloat(t) > parseFloat(157.5) &&
                    parseFloat(t) < parseFloat(180)) ||
                (parseFloat(t) < parseFloat(22.5) && parseFloat(t) > parseFloat(-22.5));
        },
        checkVelocity: function(t) {
            return parseFloat(t) < parseFloat(-0.2) ? 1 : parseFloat(t) > parseFloat(0.2) ? -1 : 0;
        }
    };
})(0, jQuery));
(Journelle.product.sizingData = (function(t, e) {
    if (window.product)
        return {
            bra: window.product.bra,
            regular: window.product.sizes
        };
})(0, jQuery));
(Journelle.product.error = (function(t, e) {
    return {
        init: function() {
            e("#product").remove(), new Vue({
                el: "#pdp-error",
                template: "<div class='pdp-error'><p class='pdp-error__message'>We're sorry! We are unable to load this product.</p><div><a class='pdp-error__link' href='/'>Shop Journelle</a></div><div><a class='pdp-error__link' href='/collections/new'>Shop New Arrivals</a></div></div>"
            });
        }
    };
})(0, jQuery));
(Journelle.product.soldOut = (function(t, e) {
    return {
        init: function() {
            t.product.wearWithComponents.init(), t.vue.directives.init();
            var n =
                e(".product-info__vendor").text() +
                " " +
                e(".product-info__title").text(),
                r = t.product.store;
            e("#product").remove(), new Vue({
                store: r,
                el: "#pdp-sold-out",
                updated: function() {
                    e(".wear-with__heading").length &&
                        e(".wear-with__heading").html("OTHER ITEMS IN THIS COLLECTION");
                },
                template: "<div class='pdp-sold-out'><p class='pdp-sold-out__message'>We're sorry! " +
                    n +
                    " is no longer available.</p><div><a class='pdp-sold-out__link' href='/'>Shop Journelle</a></div><div><a class='pdp-sold-out__link' href='/collections/new'>Shop New Arrivals</a></div><wear-with></wear-with></div>"
            });
        }
    };
})(Journelle, jQuery));
(Journelle.product.store = (function(t, e) {
    if ("product" === ENV.page.template) {
        var n = function() {
                var t = r.state.selected.sizes.bandSize + r.state.selected.sizes.cupSize;
                r.state.product.products
                    .filter(function(t) {
                        return t.active;
                    })[0]
                    .variants.forEach(function(e) {
                        e.active = e.size.toLowerCase() === t.toLowerCase();
                    });
            },
            r = new Vuex.Store({
                state: {
                    alert: {
                        product: {},
                        active: !1
                    },
                    settings: {
                        mobile: 720,
                        isMobile: document.documentElement.clientWidth < 720
                    },
                    selected: {
                        size: "",
                        zoom: !1,
                        sizeSelector: !1,
                        product: {},
                        sizes: {
                            bandSize: "",
                            cupSize: ""
                        }
                    },
                    modal: {
                        restockOpen: !1,
                        sizingOpen: !1,
                        sizingData: t.product.sizingData
                    },
                    product: window.product,
                    wearWith: [],
                    imageCache: []
                },
                mutations: {
                    showCartModal: function(t) {
                      e("html, body").animate({
                        scrollTop: e("#cart_modal_popup").offset().top - 100
                      },400);
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        n.product ? ((t.alert.product = n.product), (t.alert.active = !0)) : (t.alert.active = !t.alert.active), e("body").addClass(
                            "open-modal"
                        );
                    },
                    closeModal: function(t) {
                        (t.alert.active = !1), e("body").removeClass("open-modal");
                    },
                    updateActiveImage: function(t, e) {
                        t.product.products
                            .filter(function(t) {
                                return t.productId === e.productId;
                            })
                            .forEach(function(t) {
                                t.images.forEach(function(t) {
                                    t.active = t.thumb === e.image.thumb;
                                });
                            });
                    },
                    updateProduct: function(t, e) {
                        t.product.products.forEach(function(n) {
                            (n.active =
                                e.product.productId ===
                                n.productId), n.variants.forEach(function(e, n) {
                                t.selected.size && (e.active = t.selected.size === e.size);
                            });
                        });
                    },
                    updateVariant: function(t, e) {
                        (t.selected.size = e.variant.size), t.product.products
                            .filter(function(t) {
                                return t.active;
                            })
                            .forEach(function(t) {
                                t.variants.forEach(function(t) {
                                    t.active = t.variantId === e.variant.variantId;
                                });
                            });
                    },
                    updateWearWith: function(t, e) {},
                    updateTab: function(t, e) {
                        t.product.settings.tabs.forEach(function(t) {
                            t.active = t.property === e.tab.property;
                        });
                    },
                    updateAccordian: function(t, e) {
                        t.product.settings.tabs
                            .filter(function(t) {
                                return t.property === e.tab.property;
                            })
                            .forEach(function(t) {
                                t.active = !t.active;
                            });
                    },
                    toggleZoom: function(t, e) {
                        t.selected.zoom = e ? e.show : !t.selected.zoom;
                    },
                    cacheImage: function(t, e) {
                        t.imageCache.push(e);
                    },
                    toggleModal: function(t, e) {
                        void 0 !== e.state ? ((t.modal[e.property] = e.state), e.state ? document.body.classList.add("locked") : document.body.classList.remove("locked")) : ((t.modal[e.property] = !t.modal[
                            e.property
                        ]), document.body.classList.toggle("locked"));
                    },
                    changeTable: function(t, e) {
                        t.modal.sizingData[e.type].forEach(function(t) {
                            t.active = t.title === e.title;
                        });
                    },
                    setIsMobile: function(t, e) {
                        t.settings.isMobile = e.width < t.settings.mobile;
                    },
                    toggleSizeSelector: function(t, e) {
                        t.selected.sizeSelector = e ? e.show : !t.selected.sizeSelector;
                    },
                    updateSelectedProduct: function(t, e) {
                        t.selected.product = e.product;
                    },
                    initComboSelector: function(t, e) {
                        var n = e.size.substring(0, 2),
                            r = e.size.substring(2, e.size.length);
                        (t.selected.sizes.bandSize = n), (t.selected.sizes.cupSize = r);
                    },
                    updateSize: function(t, e) {
                        t.selected.sizes[e.property] === e.size ? (t.selected.sizes[e.property] = "") : (t.selected.sizes[e.property] = e.size);
                    },
                    fillWearWith: function(t, e) {
                        e.forEach(function(e) {
                            if (e.named_tags.images) {
                                var n = e.named_tags.images.split("|");
                                n.indexOf("z") >= 0 ? (e.image =
                                        "https://s7d2.scene7.com/is/image/Journelle/" +
                                        e.named_tags["product-id"] +
                                        "-" +
                                        e.named_tags["color-code"] +
                                        "-z?$wear-with$") : n.length &&
                                    (e.image =
                                        "https://s7d2.scene7.com/is/image/Journelle/" +
                                        e.named_tags["product-id"] +
                                        "-" +
                                        e.named_tags["color-code"] +
                                        "-" +
                                        n[0] +
                                        "?$wear-with$");
                            }
                            t.wearWith.push(e);
                        });
                    }
                },
                actions: {
                    fetchWearWith: function(t) {
                        return new Promise(function(e, n) {
                            var r = algoliasearch(
                                "8N5KJNQKJM",
                                "d7f276337a47369d25c206dd1406d4e1"
                            ).initIndex("shopify_products");
                            window.family &&
                                r.search({
                                        filters: "named_tags.family:'" + window.family + "'",
                                        numericFilters: "inventory_quantity>=1"
                                    },
                                    function(e, n) {
                                        if (e) throw e;
                                        n.nbHits, t.commit("fillWearWith", n.hits);
                                    }
                                );
                        });
                    },
                    updateRegularSize: function(t) {
                        getUrlParam("variant");
                        var e = r.state.product.products
                            .filter(function(t) {
                                return t.active;
                            })[0]
                            .variants.filter(function(t) {
                                return t.active;
                            })[0];
                        if (e) {
                            var n = {
                                variant: e
                            };
                            t.commit("updateVariant", n);
                        }
                    },
                    updateComboSize: function(t) {
                        getUrlParam("variant");
                        var e = r.state.product.products
                            .filter(function(t) {
                                return t.active;
                            })[0]
                            .variants.filter(function(t) {
                                return t.active;
                            })[0];
                        e && t.commit("initComboSelector", e);
                    }
                }
            });
        return r.watch(
            function() {
                return r.state.selected.sizes.bandSize;
            },
            function() {
                n();
            }
        ), r.watch(
            function() {
                return r.state.selected.sizes.cupSize;
            },
            function() {
                n();
            }
        ), r;
    }
})(Journelle, jQuery));
(Journelle.product.imageComponents = (function(t, e) {
    var n = t.product.util;
    return {
        init: function() {
            Vue.component("product-images", {
                props: ["product"],
                computed: {
                    selectedImage: function() {
                        return this.product.images.filter(function(t) {
                            return t.active;
                        })[0];
                    },
                    isMobile: function() {
                        return this.$store.state.settings.isMobile;
                    }
                },
                template: '<div class="product-images"><div class="images-viewer"><div class="product-images__controls" v-if="product.images.length > 0 && !isMobile"><image-thumb v-for="image in product.images" :image="image" :productId="product.productId"> </image-thumb></div><div class="product-images__container" v-if="product.images.length > 0"><image-track v-if="isMobile" :product="product"></image-track><image-regular v-for="image in product.images" :image="image" v-if="!isMobile"></image-regular><image-zoom :image="selectedImage" v-if="!isMobile"></image-zoom></div></div><wear-with v-if="!isMobile"></wear-with></div>'
            }), Vue.component("product-s7images", {
                props: ["product"],
                computed: {
                    selectedImage: function() {
                        return this.product.images.filter(function(t) {
                            return t.active;
                        })[0];
                    },
                    isMobile: function() {
                        return this.$store.state.settings.isMobile;
                    },
                    s7Assets: function() {
                        var t = "";
                        return this.product.named_tags.images &&
                            ((codes = this.product.named_tags.images.split("|")), (t =
                                this.product.named_tags["product-id"] +
                                "-" +
                                this.product.color_code +
                                "-" +
                                codes[0] +
                                "?$pdp$")), t;
                    }
                },
                mounted: function() {
                    this.$nextTick(function() {
                        (flyoutViewer = new s7viewers.FlyoutViewer({
                            containerId: "s7viewer",
                            params: {
                                asset: "Journelle/" + this.s7Assets,
                                serverurl: "https://s7d2.scene7.com/is/image/"
                            }
                        })), flyoutViewer.init();
                    });
                },
                updated: function() {
                    if (document.documentElement.clientWidth >= 720) {
                        var e = t.product.store.state.product.products
                            .filter(function(t) {
                                return t.active;
                            })[0]
                            .images.filter(function(t) {
                                return t.active;
                            })[0]
                            .regular.replace("https://s7d2.scene7.com/is/image/", "");
                        flyoutViewer.setAsset(e);
                    }
                },
                template: '<div class="product-images"><div class="images-viewer" v-show="isMobile"><div class="product-images__controls" v-if="product.images.length > 0 && !isMobile"><image-thumb v-for="image in product.images" :image="image" :productId="product.productId"> </image-thumb></div><div class="product-images__container" v-if="product.images.length > 0"><image-track v-if="isMobile" :product="product"></image-track><image-regular v-for="image in product.images" :image="image" v-if="!isMobile"></image-regular><image-zoom :image="selectedImage" v-if="!isMobile"></image-zoom></div></div><div class="images-viewer"  v-show="!isMobile"><div class="product-images__controls" v-if="product.images.length > 0"><image-thumb v-for="image in product.images" :image="image" :productId="product.productId"> </image-thumb></div><div id="s7viewer"></div></div><wear-with v-if="!isMobile"></wear-with></div>'
            }), Vue.component("image-track", {
                props: ["product"],
                data: function() {
                    return {
                        width: 0,
                        x: 0,
                        transform: "translate3d(0, 0, 0)"
                    };
                },
                computed: {
                    maxWidth: function() {
                        return this.width * this.product.images.length - this.width;
                    },
                    position: function() {
                        return _.findIndex(this.product.images, {
                            active: !0
                        });
                    }
                },
                mounted: function() {
                    var t = this;
                    (this.width = _.filter(this.$el.children, function(t) {
                        return t.classList.contains("product-images__image");
                    })[0].offsetWidth), new Hammer(this.$el, {
                        inputClass: Hammer.TouchInput,
                        threshold: 0
                    }).on("panleft panright", function(e) {
                        n.correctAngles(e.angle) &&
                            (t.$el.classList.remove("transition"), (t.transform =
                                "translate3d(-" +
                                n.keepInRange(t.x - e.deltaX, 0, t.maxWidth) +
                                "px, 0, 0)"));
                    }), new Hammer(this.$el, {
                        inputClass: Hammer.TouchInput,
                        threshold: 0
                    }).on("panend", function(e) {
                        var r = 0;
                        n.correctAngles(e.angle) &&
                            ((r = -1 * Math.round(e.deltaX / t.width)), (r = 0 !==
                                    n.checkVelocity(e.velocity) ? n.checkVelocity(e.velocity) : r), (0 === t.position && -1 === r) ||
                                (t.position === t.product.images.length - 1 && 1 === r) ? (r = 0) : t.$store.commit("updateActiveImage", {
                                    productId: t.product.productId,
                                    image: t.product.images[t.position + r]
                                })), (t.x = t.position * t.width), t.$el.classList.add("transition"), (t.transform = "translate3d(-" + n.keepInRange(t.x, 0, t.maxWidth) + "px, 0, 0)");
                    });
                },
                watch: {
                    product: function(t, e) {
                        var n = this;
                        (this.x = this.position * this.width), this.$el.classList.remove(
                            "transition"
                        ), (this.transform =
                            "translate3d(-" +
                            this.position * this.width +
                            "px, 0, 0)"), window.setTimeout(function() {
                            n.$el.classList.add("transition");
                        }, 240);
                    }
                },
                template: ' <div class="product-images__track" :style="{ transform: transform }"> <image-regular v-for="image in product.images" :image="image"></image-regular> </div> '
            }), Vue.component("image-regular", {
                props: ["image"],
                computed: {
                    initialImage: function() {
                        return "url(" + this.image.thumb;
                    },
                    cache: function() {
                        return this.$store.state.imageCache;
                    },
                    imageSize: (function(t) {
                        function e() {
                            return t.apply(this, arguments);
                        }
                        return (e.toString = function() {
                            return t.toString();
                        }), e;
                    })(function() {
                        return (imageSize = "regular");
                    })
                },
                methods: {
                    toggleZoom: function() {
                        this.$store.commit("toggleZoom");
                    }
                },
                template: ' <span class="product-images__image" :class="{ active: image.active }" :style="{ backgroundImage: initialImage }" @click="toggleZoom()" v-lazy-load="{ cache: cache, src: image[imageSize] }"> </span> '
            }), Vue.component("image-zoom", {
                props: ["image"],
                data: function() {
                    return {
                        transform: {
                            transform: "translate3d(0, 0, 0)"
                        },
                        timeout: null
                    };
                },
                computed: {
                    zoom: function() {
                        return this.$store.state.selected.zoom;
                    },
                    cache: function() {
                        return this.$store.state.imageCache;
                    },
                    imageSize: (function(t) {
                        function e() {
                            return t.apply(this, arguments);
                        }
                        return (e.toString = function() {
                            return t.toString();
                        }), e;
                    })(function() {
                        return (imageSize = "regular");
                    }),
                    isMobile: function() {
                        return this.$store.state.settings.isMobile;
                    }
                },
                methods: {
                    toggleZoom: function(t, e) {
                        document.documentElement.clientWidth < 720 &&
                            document.body.classList.toggle("locked"), (this.transform = {
                                transform: "translate3d(-" +
                                    e.offsetX +
                                    "px, -" +
                                    e.offsetY +
                                    "px, 0)"
                            }), window.clearTimeout(this.timeout), this.$store.commit(
                                "toggleZoom"
                            );
                    },
                    leaveZoom: function() {
                        var t = this;
                        window.clearTimeout(
                            this.timeout
                        ), (this.timeout = window.setTimeout(function() {
                            t.$store.commit("toggleZoom", {
                                show: !1
                            });
                        }, 250));
                    },
                    enterZoom: function() {
                        window.clearTimeout(this.timeout);
                    },
                    moveZoom: function(t, e) {
                        this.transform = {
                            transform: "translate3d(-" +
                                e.offsetX +
                                "px, -" +
                                e.offsetY +
                                "px, 0)"
                        };
                    },
                    closeZoom: function() {
                        window.clearTimeout(
                            this.timeout
                        ), this.$store.commit("toggleZoom", {
                            show: !1
                        });
                    }
                },
                mounted: function() {
                    var t = this,
                        e = _.filter(this.$el.children, function(t) {
                            return t.classList.contains("product-images__zoom-target");
                        })[0];
                    new Hammer(e, {
                        inputClass: Hammer.TouchInput,
                        threshold: 0
                    }).on("pan panup pandown", function(r) {
                        var i = e.getBoundingClientRect(),
                            o = n.keepInRange(
                                r.changedPointers[0].pageX - i.left,
                                0,
                                i.width
                            ),
                            a = n.keepInRange(
                                r.changedPointers[0].pageY - i.top,
                                0,
                                i.height
                            );
                        t.transform = {
                            transform: "translate3d(-" + o + "px, -" + a + "px, 0)"
                        };
                    });
                    var r = new Hammer(e, {
                        prevent_default: !1,
                        touchAction: "pan"
                    });
                    r
                        .get("pinch")
                        .set({
                            enable: !0
                        }), r.on("pinch pinchend pinchstart doubletap", function(t) {
                            t.preventDefault();
                        });
                },
                template: ' <div class="product-images__zoom-container" :class="{ active: zoom }" @click="toggleZoom({}, $event)" v-click-outside="closeZoom"> <div class="product-images__zoom-target" :class="{ active: zoom }" @mouseleave="leaveZoom()" @mouseenter="enterZoom()" @mousemove="moveZoom({}, $event)"> </div> <div class="product-images__zoomed" :class="{ active: zoom }" :style="transform" v-lazy-load="{ cache: cache, src: image[imageSize] }"> </div> </div> '
            }), Vue.component("mobile-zoom", {
                props: ["image"],
                computed: {
                    zoom: function() {
                        return this.$store.state.selected.zoom;
                    },
                    cache: function() {
                        return this.$store.state.imageCache;
                    },
                    imageSize: (function(t) {
                        function e() {
                            return t.apply(this, arguments);
                        }
                        return (e.toString = function() {
                            return t.toString();
                        }), e;
                    })(function() {
                        return (imageSize = "regular");
                    })
                },
                methods: {
                    closeZoom: function() {
                        this.$store.commit("toggleZoom", {
                            show: !1
                        }), document.body.classList.remove("locked");
                    }
                },
                mounted: function() {
                    var t = this.$el.children[0];
                    (this.$el.scrollTop = 0.25 * t.offsetHeight), (this.$el.scrollLeft =
                        0.25 * t.offsetWidth), (this.$el.style.display = "none");
                },
                template: ' <div class="product-images__zoom-container" :class="{ active: zoom }"> <div class="product-images__zoomed" :class="{ active: zoom }" v-lazy-load="{ cache: cache, src: image[imageSize] }" @click.prevent="closeZoom()"> </div> <button class="button--close exempt-button" @click.prevent="closeZoom()"></button> </div> '
            }), Vue.component("image-thumb", {
                props: ["productId", "image"],
                computed: {
                    initialImage: function() {
                        return "url(" + this.image.thumb;
                    },
                    cache: function() {
                        return this.$store.state.imageCache;
                    },
                    s7Assets: function() {
                        return this.image.regular.replace(
                            "https://s7d2.scene7.com/is/image/Journelle/",
                            ""
                        );
                    }
                },
                methods: {
                    updateActiveImage: function(t) {
                        this.image.active ||
                            (this.$store.commit("updateActiveImage", {
                                productId: this.productId,
                                image: t
                            }), flyoutViewer.setAsset("Journelle/" + this.s7Assets));
                    }
                },
                template: '<span class="product-images__thumb"  :class="{ active: image.active }"  @click="updateActiveImage(image)"><span class="product-images__thumb-inner"   :style="{ backgroundImage: initialImage }"   v-lazy-load="{ cache: cache, src: image.mini }"> </span></span>'
            });
        }
    };
})(Journelle, jQuery));
(Journelle.product.selectorComponents = (function(t, e) {
    function n(t, e) {
        return (
            t.split(/([0-9]+)/).filter(function(t) {
                return t.toLowerCase() === e.toLowerCase();
            }).length > 0
        );
    }
    return {
        init: function() {
            Vue.component("color-selector", {
                props: ["product"],
                computed: {
                    productsWithSwatches: function() {
                        return this.$store.state.product.products.map(function(t) {
                            return (t.swatch = t.colorHex), t;
                        });
                    },
                    isMobile: function() {
                        return this.$store.state.settings.isMobile;
                    }
                },
                methods: {
                    toggleZoom: function() {
                        document.body.classList.toggle("locked"), this.$store.commit(
                            "toggleZoom"
                        );
                    }
                },
                template: '<div class="product-info__variant-selector product-info__color-selector"><div class="product-info__variant-color"><span class="product-info__variant-name"> Color </span> <span class="product-info__variant-name">{{ product.color }}</span> </div><image-dots :product="product" v-if="isMobile"> </image-dots><div class="product-info__zoom" @click="toggleZoom()" v-if="isMobile"><svg class="icon icon-zoom"><use xlink:href="#icon-zoom"></use></svg>Zoom</div><div class="product-info__variants"><color-swatch v-for="swatchProduct in productsWithSwatches" :product="swatchProduct" :selectedProduct="product"> </color-swatch></div></div>'
            }), Vue.component("image-dots", {
                props: ["product"],
                template: ' <div class="product-info__dots"> <a class="product-info__dot" :class="{ active: image.active }" v-if="product.images.length > 1" v-for="image in product.images"> </a> </div> '
            }), Vue.component("color-swatch", {
                props: ["product", "selectedProduct"],
                computed: {
                    backgroundImage: function() {
                        return null !== this.product.swatch ? "url(" + this.product.swatch + ")" : "none";
                    },
                    light: function() {
                        return null !== this.product.swatch;
                    }
                },
                methods: {
                    updateProduct: function(t) {
                        this.$store.commit("updateProduct", t);
                        var e = setUrlParam("color", t.product.color_code);
                        history.replaceState({
                                product: !0,
                                title: t.product.title,
                                productId: t.product.productId
                            },
                            t.product.title,
                            e
                        );
                      /* Listrak Code Start*/
                      var mainUrl = document.URL;
                      var color = t.product.color;
                      var sku = t.product.productId;
                      var qoh = t.product.inventory_quantity;
                      var price = document.querySelector('.page-header .product-info__price').innerHTML;
                      var r = t.product.named_tags["images"].split("|"); 
                      
                      var mainImg = r[0];
                      var pid = t.product.named_tags["product-id"];
                      var cid = t.product.named_tags["color-code"];
                      var title = t.product.title;
                      var imageUrl = "https://s7d2.scene7.com/is/image/Journelle/" + pid +"-" +cid+ "-" + mainImg+"?$pdp$";
                      (function(d){if(typeof _ltk=="undefined"){if(document.addEventListener)document.addEventListener("ltkAsyncListener",function(){_ltk_util.ready(d)});else{e=document.documentElement;e.ltkAsyncProperty=0;e.attachEvent("onpropertychange",function(e){if(e.propertyName=="ltkAsyncProperty"){_ltk_util.ready(d)}})}}else{_ltk_util.ready(d)}})(function(){
                         // document.addEventListener('browse2',function(){
                          _ltk.Activity.AddProductBrowse(sku.toString(),{ImageURL:imageUrl,mainUrl:mainUrl,quantity:qoh,title:title,price:price});
                         //});
                      });
                      /* Listrak Code End */
                    }
                },
                template: ' <button class="product-info__color-swatch exempt-button" :class="{ light: light, active: product.active }" :style="{ backgroundColor: product.swatch, backgroundImage: backgroundImage }" :title="product.color" @click="updateProduct({ product: product })"> </button> '
            }), Vue.component("size-selector", {
                props: ["product"],
                computed: {
                    compare: function() {
                        return this.$store.state.product.sizeOrder;
                    },
                    regularSizes: function() {
                        var t = [];
                        this.$store.state.product.products.forEach(function(e) {
                            e.variants.forEach(function(e) {
                                -1 == t.indexOf(e.size) && t.push(e.size);
                            });
                        });
                        var e = this;
                        return (t = uniqValues(t)).sort(function(t, n) {
                          // if value is "A"
                          if(Number.isNaN(+t)) {
                            return (
                              e.compare.indexOf(t.toLowerCase()) -
                              e.compare.indexOf(n.toLowerCase())
                            )
                          // if value is "1"
                          } else {
                            return +t - +n;
                          }
                        });
                    },
                    activeSize: function() {
                        return this.product.variants.filter(function(t) {
                            return t.active;
                        })[0] ? this.product.variants.filter(function(t) {
                            return t.active;
                        })[0].size : "Size";
                    }
                },
                template: '<div class="product-info__variant-selector product-info__size-selector"><span class="product-info__variant-name">{{ activeSize }}</span> <div class="product-info__variants"><size-swatch-abbr v-for="regularSize in regularSizes" :regularSize="regularSize" :product="product"> </size-swatch-abbr></div></div>'
            }), Vue.component("size-swatch-abbr", {
                props: ["regularSize", "product"],
                computed: {
                    abbreviation: function() {
                        var t = null,
                            e = this;
                        return this.$store.state.product.sizes.forEach(function(n) {
                            n.title.toLowerCase() === e.regularSize.toLowerCase() && (t = n);
                        }), t ? t.abbreviation : this.regularSize;
                    },
                    isActive: function() {
                        return !!this.variant && this.variant.active;
                    },
                    isOutOfStock: function() {
                        return !!this.variant && this.variant.quantity < 1;
                    },
                    isDisabled: function() {
                        return !this.variant;
                    },
                    variant: function() {
                        var t = this;
                        return this.product.variants.filter(function(e) {
                            return e.size.toLowerCase() === t.regularSize.toLowerCase();
                        })[0];
                    },
                    style: function() {
                        if (this.abbreviation.length > 3)
                            return {
                                padding: "0.67rem 1.2rem"
                            };
                    }
                },
                methods: {
                    updateVariant: function(t) {
                        if(this.product.handle.includes('giftcard')){
                          if( this.variant.price / 100 > parseInt(this.variant.size) ) {
                            this.product.price = this.variant.price / 100;
                            this.product.comparePrice = this.variant.price / 100;
                          } else {
                            this.product.price = this.variant.price;
                            this.product.comparePrice = this.variant.price;
                          }
                        }
                        this.$store.commit("updateVariant", t);
                    }
                },
                template: '<button class="product-info__size-swatch exempt-button" v-bind:style="style" :disabled=isDisabled  :class="{ active: isActive, \'out-of-stock\': isOutOfStock, disabled: isDisabled }"  :title="regularSize"  @click="updateVariant({ variant: variant })">  {{ abbreviation }}  </button>'
            }), Vue.component("combo-selector", {
                props: ["product", "title", "property", "compare"],
                data: function() {
                    return {
                        cupSizesArray: [],
                        standard: "Euro",
                        standardTitle: "Switch to US Sizing"
                    };
                },
                computed: {
                    hasActiveSize: function() {
                        return "" !== this.activeSizes[this.property];
                    },
                    bandSizes: function() {
                        return allBandSizes.sort(function(t, e) {
                            return t - e;
                        });
                    },
                    cupSizes: function() {
                        if (!this.cupSizesArray.length) {
                            var e = this;
                            allCupSizes.forEach(function(n) {
                                var r, i, o = n;
                                t.product.sizingData.bra[0].rows.forEach(function(t) {
                                    t[0].substring(2, t[0].length).toLowerCase() ===
                                        n.toLowerCase() &&
                                        ((r = t[2].substring(2, t[2].length)), (i = t[1].substring(
                                            2,
                                            t[1].length
                                        )));
                                }), (n = {
                                    ukSize: r,
                                    usSize: i,
                                    euroSize: o
                                }), e.cupSizesArray.push(n);
                            });
                        }
                        return this.cupSizesArray;
                    },
                    availableVariants: function() {
                        var t = this.$store.state.selected.sizes.bandSize,
                            e = this.$store.state.selected.sizes.cupSize;
                        return this.product.variants
                            .filter(function(e) {
                                return e.size.includes(t);
                            })
                            .filter(function(t) {
                                return t.size.includes(e);
                            })
                            .filter(function(t) {
                                return t.quantity > 0;
                            });
                    }
                },
                methods: {
                    toggleStanderd: function() {
                        "US" == this.standard ? ((this.standard = "Euro"), (this.standardTitle =
                            "Switch to US Sizing")) : ((this.standard = "US"), (this.standardTitle =
                            "Switch to Euro Sizing"));
                    }
                },
                template: '<div class="product-info__variant-selector product-info__size-selector"><span v-if="property === \'bandSize\' " class="product-info__variant-name">{{ title }}</span><span v-if="property === \'cupSize\' " class="product-info__variant-name">{{ title }} <span class="product-info__size-standard">({{ standard }})</span></span><a v-if="property === \'cupSize\' "  @click="toggleStanderd()" class="product-info__switch-link"> {{ standardTitle }} </a><div class="product-info__variants"><band-size-swatch v-if="property === \'bandSize\'" v-for="size in bandSizes" :size="size" :property="property" :compare="compare" :product="product"></band-size-swatch><cup-size-swatch v-if="property === \'cupSize\'"  v-for="size in cupSizes" :standard="standard" :size="size" :property="property" :compare="compare" :product="product"></cup-size-swatch></div></div>'
            }), Vue.component("band-size-swatch", {
                props: ["size", "property", "compare", "product"],
                computed: {
                    activeSizes: function() {
                        return this.$store.state.selected.sizes;
                    },
                    available: function() {
                        var t = this,
                            e = this.product[this.compare].filter(function(e) {
                                return (
                                    e.toLowerCase() === t.activeSizes[t.compare].toLowerCase()
                                );
                            }).length > 0 ? this.activeSizes[this.compare] : "";
                        return this.product.variants.filter(function(t) {
                            return n(t.size, e);
                        });
                    },
                    active: function() {
                        return (
                            this.size === this.activeSizes[this.property].toLowerCase() &&
                            !this.disabled
                        );
                    },
                    disabled: function() {
                        var t = this;
                        return (
                            this.available.filter(function(e) {
                                return n(e.size, t.size);
                            }).length < 1
                        );
                    },
                    outOfStock: function() {
                        var t = this;
                        return (
                            this.available
                            .filter(function(e) {
                                return n(e.size, t.size);
                            })
                            .filter(function(t) {
                                return t.quantity > 0;
                            }).length < 1
                        );
                    }
                },
                methods: {
                    updateSize: function(t) {
                        this.disabled || this.$store.commit("updateSize", t);
                    }
                },
                template: '<button class="product-info__size-swatch exempt-button" :class="{ active: active, disabled: disabled, \'out-of-stock\': outOfStock && !disabled }" :title="size" @click.prevent="updateSize({ size: size, property: property })"> {{ size }}</button>'
            }), Vue.component("cup-size-swatch", {
                props: ["size", "property", "compare", "product", "standard"],
                computed: {
                    activeSizes: function() {
                        return this.$store.state.selected.sizes;
                    },
                    defaultSize: function() {
                        return this.size.euroSize;
                    },
                    available: function() {
                        var t = this,
                            e = this.product[this.compare].filter(function(e) {
                                return (
                                    e.toLowerCase() === t.activeSizes[t.compare].toLowerCase()
                                );
                            }).length > 0 ? this.activeSizes[this.compare] : "";
                        return this.product.variants.filter(function(t) {
                            return n(t.size, e);
                        });
                    },
                    active: function() {
                        return (
                            this.defaultSize ===
                            this.activeSizes[this.property].toLowerCase() && !this.disabled
                        );
                    },
                    disabled: function() {
                        var t = this;
                        return (
                            this.available.filter(function(e) {
                                return n(e.size, t.defaultSize);
                            }).length < 1
                        );
                    },
                    outOfStock: function() {
                        var t = this;
                        return (
                            this.available
                            .filter(function(e) {
                                return n(e.size, t.defaultSize);
                            })
                            .filter(function(t) {
                                return t.quantity > 0;
                            }).length < 1
                        );
                    }
                },
                methods: {
                    updateSize: function(t) {
                        this.disabled || this.$store.commit("updateSize", t);
                    },
                    cupSize: function() {
                        return "US" === this.standard ? this.size.usSize : "Euro" === this.standard ? this.size.euroSize : void 0;
                    }
                },
                template: '<div class="product-info__cupsize-swatchs"><button class="product-info__size-swatch exempt-button" :class="{ active: active, disabled: disabled, \'out-of-stock\': outOfStock && !disabled }" :title="cupSize()" @click.prevent="updateSize({ size: defaultSize, property: property })"> {{ cupSize() }}</button></div>'
            });
        }
    };
})(Journelle, jQuery));
(Journelle.product.contentComponents = (function(t, e) {
    return {
        init: function() {
            Vue.component("product-tabs", {
                props: ["product"],
                computed: {
                    bundle: function() {
                        return this.$store.state.product.products;
                    },
                    tabsWithContent: function() {
                        var t = this;
                        return this.$store.state.product.settings.tabs.map(function(e) {
                            return t.product[e.property] ? (e.content = t.product[e.property]) : t.bundle.filter(function(t) {
                                return "" !== t[e.property];
                            }).length ? (e.content = t.bundle.filter(function(t) {
                                return "" !== t[e.property];
                            })[0][e.property]) : (e.content = ""), e;
                        });
                    }
                },
                template: '\n                <div class="product-tabs">\n                    <tab-nav :product="product" :tabsWithContent="tabsWithContent"></tab-nav>\n                    <div class="product-tabs__content">\n                        <tab-content :product="product" :tabsWithContent="tabsWithContent"></tab-content>\n                    </div>\n                </div>\n            '
            }), Vue.component("tab-nav", {
                props: ["product", "tabsWithContent"],
                methods: {
                    updateTab: function(t) {
                        t.tab.active || this.$store.commit("updateTab", t);
                    }
                },
                template: '\n                <div class="product-tabs__nav">\n                    <button class="product-tabs__nav-item exempt-button"\n                        :class="{ active: tab.active }"\n                        v-for="(tab, index) in tabsWithContent"\n                        @click="updateTab({ tab: tab })">\n                        <span class="product-tabs__nav-text">{{ tab.name }}</span><span class="product-tabs__slash" v-if="index + 1 !== tabsWithContent.length">/</span>\n                    </button>\n                </div>\n            '
            }), Vue.component("tab-content", {
                props: ["product", "tabsWithContent"],
                mounted: function() {
                    this.$el.style.height =
                        _.filter(this.$el.children, function(t) {
                            return t.classList.contains("active");
                        })[0].offsetHeight + "px";
                },
                updated: function() {
                    this.$el.style.height =
                        _.filter(this.$el.children, function(t) {
                            return t.classList.contains("active");
                        })[0].offsetHeight + "px";
                },
                methods: {
                    openSizeModal: function() {
                        this.$store.commit("toggleModal", {
                            property: "sizingOpen"
                        });
                    }
                },
                template: '\n                <div class="product-tabs__content">\n                    <div class="product-tabs__content-wrap rte"\n                        :class="{ active: tab.active }"\n                        v-for="tab in tabsWithContent">\n                        <div v-html="tab.content"></div>\n                        <button class="product-tabs__open-modal exempt-button"\n                            v-if="tab.property === \'fitnotes\'"\n                            @click="openSizeModal()">\n                            Size Conversion Chart\n                        </button>\n                    </div>\n                </div>\n            '
            }), Vue.component("product-accordian", {
                props: ["product"],
                computed: {
                    bundle: function() {
                        return this.$store.state.product.products;
                    },
                    tabsWithContent: function() {
                        var t = this;
                        return this.$store.state.product.settings.tabs.map(function(e) {
                            return t.product[e.property] ? (e.content = t.product[e.property]) : t.bundle.filter(function(t) {
                                return "" !== t[e.property];
                            }).length ? (e.content = t.bundle.filter(function(t) {
                                return "" !== t[e.property];
                            })[0][e.property]) : (e.content = ""), e;
                        });
                    }
                },
                template: '<div class="product-accordian">  <accordian-item v-for="(tab, index) in tabsWithContent"   :tab="tab">  </accordian-item> </div>'
            }), Vue.component("accordian-item", {
                props: ["tab"],
                methods: {
                    openSizeModal: function() {
                        this.$store.commit("toggleModal", {
                            property: "sizingOpen"
                        });
                    },
                    updateAccordian: function(t) {
                        this.$store.commit("updateAccordian", t);
                    }
                },
                template: '<div class="product-accordian__item" :class="{ active: tab.active }"><button class="product-accordian__title exempt-button" @click.prevent="updateAccordian({ tab: tab })"><span class="product-accordian__icon"></span> {{ tab.name }}</button> <div class="product-accordian__content rte"><div class="product-accordian__inside" v-html="tab.content"></div></div></div>'
            });
        }
    };
})(0, jQuery));
(Journelle.product.wearWithComponents = (function(t, e) {
    var n, r;
    Journelle.product.util;
    return {
        init: function() {
            Vue.component("wear-with", {
                data: function() {
                    return {
                        wearWithProducts: this.$store.state.wearWith
                    };
                },
                computed: {
                    activeProduct: function() {
                        return this.$store.state.product.products.filter(function(t) {
                            return t.active;
                        })[0];
                    },
                    isMobile: function() {
                        return this.$store.state.settings.isMobile;
                    },
                    wearWith: function() {
                        var t = this;
                        this.$store.state.wearWith.length ||
                            this.$store.dispatch("fetchWearWith").then(function() {
                                t.wearWithProducts = t.$store.state.wearWith;
                            });
                    },
                    updateWearWith: function() {
                        var t, e;
                        if (this.activeProduct)
                            (e = this.activeProduct.color_code), (t = this.activeProduct
                                .title);
                        else {
                            var n = getUrlParam("color");
                            (e = null != n ? n : window.sProducts[0].color_code), (t =
                                window.sProducts[0].title);
                        }
                        return this.$store.state.wearWith.length &&
                            (this.wearWithProducts = this.$store.state.wearWith.filter(
                                function(n) {
                                    return n.named_tags["color-code"] == e && n.title != t;
                                }
                            )), this.swiperUpdate(), this.wearWithProducts.length;
                    },
                    numberOfItems: function() {
                        return 1 === this.wearWithProducts.length ? "1 Item" : this.wearWithProducts.length + " Items";
                    }
                },
                updated: function() {
                    this.$nextTick(function() {
                        this.updateWearWith, this.swiperUpdate();
                    });
                },
                mounted: function() {
                    this.$nextTick(function() {
                        this.wearWith, this.updateWearWith, this.swiperInit();
                    });
                },
                methods: {
                    swiperInit: function() {
                        n = new Swiper("#wear-with-swiper", {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            speed: 400,
                            spaceBetween: 30,
                            navigation: {
                                nextEl: "#wear-with .swiper-button-next",
                                prevEl: "#wear-with .swiper-button-prev"
                            },
                            breakpoints: {
                                1024: {
                                    slidesPerView: 2,
                                    slidesPerGroup: 2,
                                    spaceBetween: 30
                                },
                                720: {
                                    slidesPerView: 2,
                                    slidesPerGroup: 2,
                                    spaceBetween: 10
                                }
                            }
                        });
                    },
                    swiperUpdate: function() {
                        n && (n.update(), n.slideTo(0));
                    }
                },
                template: '<section class="wear-with" :class="{ nospace: wearWithProducts.length == 0}" id="wear-with"><div class="swiper-container wear-with-swiper" id="wear-with-swiper"><h3 class="wear-with__heading" v-if="updateWearWith > 0"><span class="wear-with__heading-content">{{numberOfItems}} In This Collection</span></h3><div class="swiper-wrapper wear-with__content"><wear-with-product v-for="product in wearWithProducts" :product="product"></wear-with-product></div></div><div class="swiper-button-prev"></div><div class="swiper-button-next"></div></section>'
            }), Vue.component("wear-with-product", {
                props: ["product"],
                computed: {
                    cache: function() {
                        return this.$store.state.imageCache;
                    },
                    isMobile: function() {
                        return this.$store.state.settings.isMobile;
                    }
                },
                template: '<div class="wear-with__item swiper-slide"><a :href="\'/products/\' + product.named_tags[\'canonical\'] +\'?color=\'+product.named_tags[\'color-code\']" class="wear-with__image"  v-lazy-load="{ cache: cache, src: product.image}"></a><h4 class="wear-with__title">{{ product.title }}</h4></div>'
            }), Vue.component("modal-wear-with", {
                data: function() {
                    return {
                        wearWithProducts: this.$store.state.wearWith
                    };
                },
                computed: {
                    activeProduct: function() {
                        return this.$store.state.product.products.filter(function(t) {
                            return t.active;
                        })[0];
                    },
                    updateWearWith: function() {
                        if (this.activeProduct) {
                            var t = this.activeProduct.color_code,
                                e = this.activeProduct.title;
                            return this.$store.state.wearWith.length &&
                                (this.wearWithProducts = this.$store.state.wearWith.filter(
                                    function(n) {
                                        return n.named_tags["color-code"] == t && n.title != e;
                                    }
                                )), this.swiperUpdate(), this.wearWithProducts.length;
                        }
                    }
                },
                updated: function() {
                    this.$nextTick(function() {
                        this.updateWearWith, this.swiperUpdate();
                    });
                },
                mounted: function() {
                    this.$nextTick(function() {
                        this.updateWearWith, this.swiperInit();
                    });
                },
                methods: {
                    swiperInit: function() {
                        r = new Swiper("#modal-wear-with-swiper", {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                            speed: 400,
                            navigation: {
                                nextEl: "#modal-wear-with .swiper-button-next",
                                prevEl: "#modal-wear-with .swiper-button-prev"
                            },
                            breakpoints: {
                                1024: {
                                    slidesPerView: 2,
                                    slidesPerGroup: 2,
                                    spaceBetween: 30
                                },
                                720: {
                                    slidesPerView: "auto",
                                    slidesPerGroup: 2,
                                    spaceBetween: 10
                                }
                            }
                        });
                    },
                    swiperUpdate: function() {
                        r && (r.update(), r.slideTo(0));
                    }
                },
                template: '<section class="wear-with" :class="{ nospace: wearWithProducts.length == 0}" id="modal-wear-with"><div class="swiper-container modal-wear-with-swiper" id="modal-wear-with-swiper"><h3 class="wear-with__heading" v-if="updateWearWith > 0">Shop the Collection</h3><div class="swiper-wrapper modal-wear-with__content"><modal-wear-with-product v-for="product in wearWithProducts" :product="product"></modal-wear-with-product></div></div><div class="swiper-button-prev"></div><div class="swiper-button-next"></div></section>'
            }), Vue.component("modal-wear-with-product", {
                props: ["product"],
                computed: {
                    cache: function() {
                        return this.$store.state.imageCache;
                    }
                },
                template: '<div class="wear-with__item swiper-slide"><a :href="\'/products/\' + product.named_tags[\'canonical\'] +\'?color=\'+product.named_tags[\'color-code\']" class="wear-with__image"  v-lazy-load="{ cache: cache, src: product.image}"></a><h4 class="wear-with__title">{{ product.title }}</h4></div>'
            }), e(window).resize(function() {
                n.update(), r && r.update();
            });
        }
    };
})(0, jQuery));
(Journelle.product.infoComponents = (function(t, e) {
    return {
        init: function() {
            t.product.selectorComponents.init(), t.product.contentComponents.init(), Vue.component(
                "product-info", {
                    props: ["product", "showSale"],
                    data: function() {
                        return {
                            mobile: document.documentElement.clientWidth < 720
                        };
                    },
                    computed: {
                        isBraSizing: function() {
                            return this.product.cupSize && this.product.bandSize;
                        },
                        isMobile: function() {
                            return this.$store.state.settings.isMobile;
                        },
                        wearWith: function() {
                            return this.product.wearWith.filter(function(t) {
                                return null !== t;
                            });
                        },
                        vendorHandle: function() {
                            return this.product.vendor
                                .toLowerCase()
                                .replace(/[^\w ]/g, "")
                                .replace(/ /g, "-");
                        }
                    },
                    methods: {
                        openSizeModal: function() {
                            this.$store.commit("toggleModal", {
                                property: "sizingOpen"
                            });
                        }
                    },
                    mounted: function() {
                        this.$nextTick(function() {
                            var t = this;
                            e(window).resize(function() {
                                t.mobile = document.documentElement.clientWidth < 720;
                            });
                            var copy = this.$el.querySelector('.product-info__prices');
                            var paste = document.querySelector('#product-pricing');
                            if (copy && paste) {
                                paste.innerHTML = copy.innerHTML;
                            }
                            window.dispatchEvent(new Event('GRInit'));
                        });
                    },
                    updated: function() {
                        this.$nextTick(function() {
                            var copy = this.$el.querySelector('.product-info__prices');
                            var paste = document.querySelector('#product-pricing');
                            if (copy && paste) {
                                paste.innerHTML = copy.innerHTML;
                            }
                        });
                    },
                    template: '<div class="product-info"><form method="post" action="/cart/add" enctype="multipart/form-data" @click.prevent=""><h2 class="product-info__vendor" rel="test2"> <a :href="\'/collections/\' + vendorHandle">{{ product.vendor }}</a> </h2><div class="product-info__title-wrap"><h1 class="product-info__title">{{ product.title }}</h1> <div class="product-info__prices"><span class="product-info__compare" v-if="product.comparePrice > product.price">{{ product.comparePrice | money }}</span> <span class="product-info__price" >{{ product.price | money }}</span></div> </div> <color-selector :product="product"></color-selector><combo-selector :product="product" :title="\'Band Size\'" :property="\'bandSize\'" :compare="\'cupSize\'" v-if="isBraSizing"></combo-selector><combo-selector :product="product" :title="\'Cup Size\'" :property="\'cupSize\'" :compare="\'bandSize\'" v-if="isBraSizing"></combo-selector><size-selector :product="product" v-if="!isBraSizing"> </size-selector><!--<button class="product-tabs__open-modal exempt-button" @click="openSizeModal()" v-if="isBraSizing">Size Guide</button>--><add-to-cart :product="product"></add-to-cart></form><product-accordian :product="product"></product-accordian><wear-with v-if="mobile"></wear-with></div>'
                }
            ), Vue.component("wear-with-link", {
                props: ["url", "text"],
                methods: {
                    scrollTo: function(t) {
                        e("html, body").animate({
                                scrollTop: e(t).offset().top - 100
                            },
                            400
                        );
                    }
                },
                template: ' <div class="product-info__links"> <a :href="url" class="product-info__link" @click.prevent="scrollTo(url)">{{ text }}</a> </div> '
            });
        }
    };
})(Journelle, jQuery));
(Journelle.product.modalComponents = (function(t, e) {
    return {
        init: function() {
            t.product.sizingData, Vue.component("notify-me", {
                data: function() {
                    return {
                        message: null,
                        disabled: !1,
                        hidden: !1,
                        inputFilled: !1
                    };
                },
                computed: {
                    activeProduct: function() {
                        return this.$store.state.product.products.filter(function(t) {
                            return t.active;
                        })[0];
                    },
                    activeVariant: function() {
                        return this.activeProduct.variants.filter(function(t) {
                            return t.active;
                        })[0];
                    },
                   selectedVariantName: function() {
                        var t = this.$store.state.product.products.filter(function(t) {
                            return t.active;
                        })[0];
                        if (this.activeVariant)
                            return this.activeVariant.size + " | " + t.color;
                    },
                  selectedProductName: function() {
                        var t = this.$store.state.product.products.filter(function(t) {
                            return t.active;
                        })[0];
                        if (t)
                            return t.title;
                    },
                  selectedProductVendor: function() {
                        var t = this.$store.state.product.products.filter(function(t) {
                            return t.active;
                        })[0];
                        if (t)
                            return t.vendor;
                    },
                    closeMessage: function() {
                        return this.hidden ? "Close" : "Nevermind";
                    }
                },
                methods: {
                    close: function() {
                        this.$store.commit("toggleModal", {
                            property: "restockOpen"
                        });
                    },
                    userInput: function() {
                        this.inputFilled =
                            "" !== this.$el.querySelector("#notify-email").value;
                    },
                    addRestock: function() {
                        /*var t = this,
                            e = this.$el.querySelector("#notify-email").value;
                        e && "" !== e ? ((this.disabled = !0), BIS.create(
                            e,
                            this.activeVariant.variantId,
                            this.activeProduct.productId
                        ).then(function(e) {
                            if ("OK" === e.status)
                                (t.message =
                                    "We'll let you know when it's back in stock."), (t.hidden = !0);
                            else if ("Error" === e.status) {
                                var n = "Whoops, we weren't able to add you to the list.";
                                e.errors &&
                                    e.errors.email &&
                                    (n = e.errors.email.join(
                                        " "
                                    )), (t.hidden = !1), (t.disabled = !1), (t.message = n);
                            } else
                                (t.hidden = !1), (t.disabled = !1), (t.message =
                                    "Unknown error, please try again later.");
                        })) : ((this.message =
                            "Please enter an email address."), (this.disabled = !1), (this.hidden = !1));*/
                        var productSKU = this.activeVariant.variantId;
                        var emailAddress = document.getElementById ('txtEmailAddress') .value;
                        var alertCode = document.getElementById ('hdnAlertCode') .value;
                        _ltk.Alerts.AddAlertWithIdentifiers({Identifiers:{Email:emailAddress}, Sku:productSKU, AlertCode:alertCode});
                        _ltk.Alerts.Submit();
                        document.getElementById("product-notify__message").innerHTML = 'Thank you! We will notify you when this product becomes available.';
                    }
                },
            template: ' <div class="product-notify"> <h2 class="product-notify__heading">Keep Me Posted</h2><p class="product-notify__message" id="product-notify__message">Enter your contact info and we’ll notify you if this item comes back in stock.<br/><b class="page-title2">{{selectedProductName}}</b><span class="product-vendor2">{{selectedProductVendor}}</span><span>{{selectedVariantName}}</span></p>Email Address<input id="txtEmailAddress" type="text" name="txtEmailAddress" ><input id="hdnAlertCode" type="hidden" value="BIS" name="hdnAlertCode"><br/><button @click="addRestock()" name="SubmitAlert">Notify Me</button> <button class="product-notify__close exempt-button notify-closeBTN" @click="close()">{{ closeMessage }}</button> </div> '
           }), Vue.component("sizing", {
                computed: {
                    activeProduct: function() {
                        return this.$store.state.product.products.filter(function(t) {
                            return t.active;
                        })[0];
                    },
                    sizingProperty: function() {
                        return isNaN(parseInt(this.activeProduct.variants[0].size)) ? "regular" : "bra";
                    },
                    sizingData: function() {
                        return this.$store.state.modal.sizingData[this.sizingProperty];
                    },
                    isMobile: function() {
                        return this.$store.state.settings.isMobile;
                    }
                },
                methods: {
                    close: function() {
                        this.$store.commit("toggleModal", {
                            property: "sizingOpen"
                        });
                    }
                },
                template: ' <div class="product-sizing"> <header class="product-sizing__header" v-if="isMobile"> <button class="button--close-arrow product-sizing__close exempt-button" @click.prevent="close()"></button> <h4 class="product-sizing__title">Size Guide</h4> </header> <div class="product-sizing__content"> <div class="product-sizing__wrap"> <h2 class="product-sizing__heading" v-if="!isMobile">Size Guide</h2> <div class="product-sizing__message"></div> <sizing-dropdown :data="sizingData"></sizing-dropdown> <sizing-table :data="sizingData"></sizing-table> </div> </div> </div> '
            }), Vue.component("sizing-table", {
                props: ["data"],
                computed: {
                    activeTable: function() {
                        return this.data.filter(function(t) {
                            return t.active;
                        })[0];
                    }
                },
                template: ' <table class="product-table"> <thead class="product-table__header"> <table-row :row="activeTable.header"></table-row> </thead> <tbody class="product-table__content"> <table-row v-for="row in activeTable.rows" :row="row"></table-row> </tobdy> </table> '
            }), Vue.component("table-row", {
                props: ["row"],
                template: ' <tr class="product-table__row"> <td class="product-table__item" v-for="item in row">{{ item }}</td> </tr> '
            }), Vue.component("sizing-dropdown", {
                props: ["data"],
                data: function() {
                    return {
                        open: !1
                    };
                },
                computed: {
                    activeTable: function() {
                        return this.data.filter(function(t) {
                            return t.active;
                        })[0];
                    }
                },
                methods: {
                    toggleDropdown: function(t) {
                        this.open = t ? t.open : !this.open;
                    },
                    changeTable: function(t) {
                        t.active ||
                            (this.$store.commit("changeTable", t), (this.open = !1));
                    }
                },
                template: ' <div class="select-dropdown" :class="{ active: open }" v-click-outside="toggleDropdown"> <div class="select-dropdown__selected" @click="toggleDropdown()"> <span class="select-dropdown__label">Band Size</span> {{ activeTable.title }} </div> <div class="select-dropdown__options"> <span class="select-dropdown__option" :class="{ active: table.active }" v-for="table in data" @click="changeTable(table)"> {{ table.title }} </span> </div> </div> '
            });
        }
    };
})(Journelle, jQuery));
(Journelle.product.components = (function(t, e) {
    return {
        init: function() {
            t.product.imageComponents.init(), t.product.infoComponents.init(), t.product.wearWithComponents.init(), t.product.modalComponents.init(), Vue.component(
                "product", {
                      data: function() {
                        return {
                            finalSaleEl: '',
                            exchangeSaleEl: ''
                        };
                    },
                    computed: {
                        activeProduct: function() {
                            return this.$store.state.product.products.filter(function(t) {
                                return t.active;
                            })[0];
                        },
                        isFlyoutViewer: function() {
                            return !!this.activeProduct.named_tags.images;
                        },
                        selectedImage: function() {
                            return this.activeProduct.images.filter(function(t) {
                                return t.active;
                            })[0];
                        },
                        isMobile: function() {
                            return this.$store.state.settings.isMobile;
                        },
                        isExchangeSale: function() {
                          return (
                                this.activeProduct.named_tags['custom-tag'] &&
                                this.activeProduct.named_tags['custom-tag'].indexOf('exchange-sale') != -1
                            ) && 
                            (this.activeProduct.named_tags['custom-tag'].indexOf('final-sale') == -1
                               || (
                                this.activeProduct.named_tags.price &&
                                this.activeProduct.named_tags.price == 'full-price'
                            )) ;
                        },
                        isFinalSale: function() {
                            return ((
                                this.activeProduct.named_tags.price &&
                                this.activeProduct.named_tags.price == 'sale'
                            ) ||
                            (
                                this.activeProduct.named_tags['custom-tag'] &&
                                this.activeProduct.named_tags['custom-tag'].indexOf('final-sale') != -1
                            )) && !this.isExchangeSale;
                        }
                    },
                    mounted() {
                      this.finalSaleEl = document.querySelector('.product-info__sale.sale_final');
                      this.exchangeSaleEl = document.querySelector('.product-info__sale.sale_exchange');
                      
                      if(this.finalSaleEl) {
                        this.finalSaleEl.classList.toggle('is-hidden', !this.isFinalSale);
                      }
                      if(this.exchangeSaleEl) {
                        this.exchangeSaleEl.classList.toggle('is-hidden', !this.isExchangeSale);
                      }
                    },
                    updated() {
                      if(this.finalSaleEl) {
                        this.finalSaleEl.classList.toggle('is-hidden', !this.isFinalSale);
                      }
                      if(this.exchangeSaleEl) {
                        this.exchangeSaleEl.classList.toggle('is-hidden', !this.isExchangeSale);
                      }
                    },
                    template: '<section class="product__main"><div class="product__main-content"><mobile-zoom :image="selectedImage" v-if="isMobile"></mobile-zoom><product-s7images v-if="isFlyoutViewer" :product="activeProduct"></product-s7images><product-images v-if="!isFlyoutViewer" :product="activeProduct"></product-images><product-info :product="activeProduct"></product-info></div></section>'
                }
            );
            var n = t.cart.store;
            Vue.component("add-to-cart", {
                props: ["product", "withPrice", "ignorePopup"],
                data: function() {
                    return {
                        errorMessage: !1,
                        addToWishlist: !1,
                        variantWishlistId: !1,
                        productWishlistId: !1
                    };
                },
                computed: {
                    selectedVariant: function() {
                        (this.productWishlistId = !1), (this.variantWishlistId = !1);
                        var t = this,
                            n = this.product.variants.filter(function(n) {
                                return n.active &&
                                    ((t.variantWishlistId = n.variantId), (t.productWishlistId =
                                            t.product.productId), e(
                                            "#smartwishlist,#smartwishlist2"
                                        ).remove(), e(
                                            '<div id="smartwishlist" data-product="' +
                                            t.productWishlistId +
                                            '" data-variant="' +
                                            t.variantWishlistId +
                                            '"></div>'
                                        ).insertAfter("button.product__add"), "function" ==
                                        typeof ReloadSmartWishlist &&
                                        ReloadSmartWishlist()), n.active;
                            })[0];
                        return (void 0 !== n && null !== n) ||
                            (e("#smartwishlist,#smartwishlist2").remove(), e(
                                '<div id="smartwishlist"><div id="bookmarkit" status="unbookmarked" class="unbookmarked"> </div></div>'
                            ).insertAfter("button.product__add"), e(
                                "#smartwishlist"
                            ).on("click", function() {
                                t.updateWishList();
                            })), n;
                    },
                    selectedVariantName: function() {
                        var t = this.$store.state.product.products.filter(function(t) {
                            return t.active;
                        })[0];
                        if (this.selectedVariant)
                            return this.selectedVariant.size + " | " + t.color;
                    },
                    outOfStock: function() {
                        return !!this.selectedVariant && this.selectedVariant.quantity < 1;
                    },
                    buttonText: function() {
                       var btnText = (!!this.selectedVariant && this.selectedVariant.quantity < 1) ? "Out of Stock" : "Add to bag";
                        return "function" != typeof ReloadSmartWishlist &&
                            (e("#smartwishlist,#smartwishlist2").remove(), e(
                                '<div id="smartwishlist" data-product="' +
                                this.productWishlistId +
                                '" data-variant="' +
                                this.variantWishlistId +
                                '"></div>'
                            ).insertAfter("button.product__add")), btnText;
                    },
                    whishlistLinkDisabledClass: function() {
                        return "disable-whishlist-link";
                    },
                    amountInCart: function() {
                        var t = this;
                        if (this.selectedVariant) {
                            var e = n.state.products.filter(function(e) {
                                return e.variantId === t.selectedVariant.variantId;
                            })[0];
                            return void 0 !== e ? e.amount : 0;
                        }
                        return 0;
                    },
                    mappedProduct: function() {
                        var t = _.clone(this.product),
                            e = this.product.variants.filter(function(t) {
                                return t.active;
                            })[0];
                        return _.each(e, function(e, n) {
                            t[n] = e;
                        }), (t.amount = this.amountInCart), t;
                    }
                },
                methods: {
                    notifyMe: function() {
                        this.$store.commit("toggleModal", {
                            property: "restockOpen"
                        });
                    },
                    updateCart: function(t) {
                        this.selectedVariant ? this.selectedVariant.quantity < 1 ||
                            (n.commit("addProduct", t), n.commit(
                                "addToQueue",
                                this.mappedProduct
                            ), this.$store.commit(
                                "showCartModal",
                                t
                            ), this.$store.commit("toggleSizeSelector", {
                                show: !1
                            })) : (this.errorMessage = !0);
                      //console.log(this.selectedVariant);
                            /*gtag('event', 'add_to_cart',{ 
                              'currency':'USD', 
                              'value': this.selectedVariant.price / 100,
                              'items' : [
                              {
                              'item_id': this.selectedVariant.id,
                              'item_name': this.selectedVariant.title,
                              'item_variant':this.selectedVariant.sku,
                              'price':this.selectedVariant.price / 100,
                              'quantity':1
                            }]
                      });*/
                      
                    },
                    updateWishList: function() {
                        this.selectedVariant ? (this.errorMessage = !1) : ((this.errorMessage = !0), e(
                            "#smartwishlist #bookmarkit"
                        ).off(), e("#smartwishlist #bookmarkit").attr(
                            "class",
                            "unbookmarked"
                        ), e("#smartwishlist #bookmarkit").attr(
                            "status",
                            "unbookmarked"
                        ));
                    }
                },
                mounted: function() {
                    this.$nextTick(function() {
                        e("#smartwishlist").bind("DOMSubtreeModified", function() {
                            setTimeout(function() {
                                !e("#smartwishlist #bookmarkit").length ||
                                    this.addToWishlist ||
                                    this.selectedVariant ||
                                    (e("#smartwishlist #bookmarkit").off(), e(
                                        "#smartwishlist #bookmarkit"
                                    ).attr("class", "unbookmarked"), e(
                                        "#smartwishlist #bookmarkit"
                                    ).attr("status", "unbookmarked"), (this.addToWishlist = !0));
                            }, 500);
                        });
                    });
                    if (window.affirm) {
                        affirm.ui.ready(function() {
                            affirm.ui.refresh();
                        });
                    }

                },
                template: '<div><div class="product__add-notifyme" v-show="selectedVariant && selectedVariant.quantity < 1"><span class="product__add-selected-variant">{{ selectedVariantName }}</span><a @click="notifyMe()">Notify me if this item comes back in stock</a></div><div v-show="selectedVariant && selectedVariant.quantity < 1"><span class="product__add-instock-error">Please select an in-stock size</span></div>\
                <div class="product-add-buttons">\
                <input type="hidden" name="id" :value="variantWishlistId" />\
                <button type="button" class="button secondary product__add product__add-add-to-bag"  :disabled="selectedVariant && selectedVariant.quantity < 1" :class="{ \'with-price\': withPrice }" @click="updateCart({ product: mappedProduct })">{{ buttonText }} <span class="product__add-price" v-if="withPrice">{{ mappedProduct.price | money }}</span> </button><div id="smartwishlist" :data-product="productWishlistId" :data-variant="variantWishlistId" @click.prevent.stop="updateWishList()"></div>\
                </div>\
                <div class="gift-reggie-registry-button"><input type="hidden" class="gift-reggie-hook" value=""></div>\
                <p class="affirm-as-low-as" data-page-type="product" :data-amount="product.price"></p>\
                <span class="product__add-error" v-show="!selectedVariant && errorMessage">Please select a size</span></div>',
                updated: function() {
                  if (window.affirm) {
                      affirm.ui.ready(function() {
                        affirm.ui.refresh();
                      });
                  }
                }
            });
        }
    };
})(Journelle, jQuery));
(Journelle.router = (function(t, e) {
    var environment = window.ENV || {
            page: {},
            sections: []
        },
        r = {
            initial: function() {
                RC.floatingLabels.floatMyLabels(
                    ".floating-label input"
                ), RC.floatingLabels.floatMyLabels(
                    ".floating-label textarea"
                ), t.lazy.loadBackground(
                    ".js-lazy-background"
                ), t.lazy.loadImage(".js-lazy");
            },
            deferred: function() {
                document.body.addEventListener("shopify:section:load", function(e) {
                    e.target.classList.contains("shopify-section") &&
                        (t.lazy.loadBackground(".js-lazy-background"), t.lazy.loadImage(
                            ".js-lazy"
                        ));
                });
            }
        };
    return {
        init: function() {
            if ((r.initial(), void 0 !== t.templates[environment.page.template_default]))
                if ("product" === environment.page.template_default) {
                    var e = algoliasearch(
                        "8N5KJNQKJM",
                        "d7f276337a47369d25c206dd1406d4e1"
                    ).initIndex("shopify_variants");
                    window.canonical &&
                        e.search({
                                filters: "named_tags.canonical:'" + window.canonical + "'",
                                facets: [
                                    "vendor",
                                    "product_type",
                                    "named_tags.base-color",
                                    "price_range",
                                    "options.size",
                                    "options.color"
                                ],
                                hitsPerPage: 1000
                            },
                            function(e, r) {
                                try {
                                    if (e) throw e;
                                    var i = !0;
                                    r.hits.length > 0 ? (fillCanonicalProducts(r.hits, r.facets), t.templates[
                                        environment.page.template_default
                                    ].init(), t.product.store.dispatch("updateComboSize")) : ((i = !1), t.product.soldOut.init()), addProductSchema(
                                        i,
                                        window.product.products.filter(function(t) {
                                            return t.active;
                                        })[0]
                                    );
                                } catch (e) {
                                    console.log(e), t.product.error.init();
                                }
                            }
                        );
                } else t.templates[environment.page.template_default].init();
            _.uniq(environment.sections).forEach(function(e) {
                void 0 !== t.sections[e] && t.sections[e].init();
            }), r.deferred();
        },
        autoInit: r
    };
})(Journelle, jQuery));

Journelle.router.init();